{
  "adgroup": {
    "alwaysFirst": "Always first",
    "archiveWarning": "You are about to permanently archive this Adgroup. No data will be lost but you won't be able to activate it again. Do you want to permanently archive this Adgroup ?",
    "created": "New Adgroup Created !",
    "updated": "Your Adgroup has been updated !",
    "goToAdgroup": "Go to {{adgroupName}}",
    "sectionTitle": "Adgroup Summary",
    "appendClickId": "Append Click ID",
    "type": "Type",
    "format": "Format",
    "redirectUrl": "Redirect URL",
    "redirectUrlDoubleClickWarning": "It is impossible to forward the click id, on a DoubleClick link, without adding the destination link at the end.",
    "rulesExceptionsLabel": "Geographic rule exclusion",
    "rulesExceptions": "You can block the countries that you don't want to deal with. The traffic from these countries will be redirected to the following redirect url instead of the default one.",
    "redirectUrlHelper": "It must include tracking parameters. If no URL is specified in the creative, this default URL will be used",
    "channels": "Channels",
    "redirectUrlUtmGenerator": {
      "title": "Redirect URL helper",
      "generateUrl": "Generate URL",
      "generatedUrl": "Generated URL",
      "utmDetectedMessage": "Existing UTM keys detected in the current URL: {{keys}}. Generating will update these keys.",
      "utmParameters": "UTM parameters",
      "valueType": "Type",
      "customValue": "Custom",
      "dynamicValue": "Dynamic",
      "parameterValue": "Value",
      "noUtmFound": "No UTM parameters found in redirect URL.",
      "initializeDefaultUtm": "Add default UTM",
      "resetDefaultUtm": "Reset default UTM",
      "customParameters": "Custom parameters",
      "addParameter": "Add parameter",
      "noCustomParameters": "No custom parameters.",
      "documentation": "Documentation",
      "defaultUtmValues": "Default UTM values",
      "applyToRedirectUrl": "Apply to redirect URL",
      "serverTokens": {
        "title": "Server replacement tokens",
        "groups": {
          "advertiserInfo": "Advertiser info",
          "publisherInfo": "Publisher info"
        },
        "clickIdAutoNote": "Note: {clickId} is added automatically when missing.",
        "descriptions": {
          "campaignId": "Identifier of the campaign",
          "campaignName": "Name of the campaign",
          "adGroupId": "Identifier of the ad group",
          "adGroupName": "Name of the ad group",
          "adcopyInfos": "Creative infos",
          "adCopyId": "Identifier of the creative",
          "adCopyName": "Name of the creative",
          "clickId": "Unique click identifier (added automatically if missing)",
          "publisherInfos": "Publisher infos",
          "pubName": "Publisher name",
          "siteName": "Name of the website",
          "posName": "Name of the position"
        }
      }
    },
    "channelsHelper": "Channels group Ad Positions by channel type. 'Email' corresponds to Native Ads within Newsletter/Emails, while 'Web' is native Ads on websites",
    "network": "Network",
    "notFound": "AdGroup not found",
    "create": "Create New Adgroup",
    "edit": {
      "sectionTitle": "Modify Adgroup"
    },
    "details": {
      "title": "Details",
      "archived": "Archived",
      "budgetCapping": "Capping",
      "companyName": "Company",
      "costType": "Type",
      "costValueWithCurrency": "Cost",
      "dailyBudgetWithCurrency": "Daily Budget",
      "marketCode": "Market",
      "network": "Network",
      "resellerName": "Reseller",
      "impressionPixels": "Impression pixels",
      "clickPixels": "Click pixels",
      "commission": "Commission",
      "campaignId": "Select the new adgroup's campaign",
      "type": "Type"
    },
    "budgetAndDates": {
      "title": "Budgets And Dates",
      "dailyBudgetTypeHelper": "- Fixed: The daily budget is fixed.<br />- Open: The daily budget has no limit.<br />- Automatic: The daily budget is automatically calculated based on the budget capping and the end date.",
      "dailyBudgetHelper": "This is the maximum Adgroup budget per day. It can be adjusted later",
      "budgetCapping": "Budget Capping",
      "budgetCappingHelper": "This optionnal setup will limit the monthly or total adgroup budget. Adgroup will stop when the budget is reached.",
      "budgetCappingPeriod": "Period",
      "budgetTypeLabel": "Daily Budget Type",
      "budgetType": {
        "Fixed": "Fixed",
        "Open": "No limit",
        "Auto": "Automatic"
      },
      "dateHelper": "This optional setup allows you to set custom dates for your adgroup. Dates are included. The adgroup will start at 00:01 and stop at 23:59.",
      "endDateValidation": "The end date cannot be before the start date",
      "budgetCappingType": "Budget capping type",
      "budgetCappingTypeHelper": "- Monthly: The budget resets at the start of each month.<br />- No limit: The budget is unlimited.<br />- Overall: The budget is a lifetime limit.<br />- Period: The budget applies from the start date until the end of the adgroup.",
      "overallCalculator": {
        "title": "Overall budget calculator",
        "open": "Adjust overall budget",
        "currentBudget": "Current budget",
        "leftToSpend": "Left to spend",
        "amount": "Amount to add or remove",
        "amountHelper": "Enter a positive amount to increase the budget, or a negative amount to decrease it.",
        "preview": "Preview",
        "newBudget": "New budget",
        "newLeftToSpend": "New left to spend",
        "apply": "Apply to budget",
        "outOfBounds": "The new budget must be between {{min}} and {{max}}."
      },
      "budgetPlans": {
        "button": "Plan changes",
        "title": "Planned budget changes",
        "add": "Add a planned change",
        "edit": "Edit planned change",
        "editTitle": "Edit planned change",
        "plannedDate": "Execution date",
        "dateHelper": "The change is applied by the daily job on or after this date. Only dates starting tomorrow can be planned.",
        "unchanged": "No change",
        "empty": "No planned budget changes",
        "delete": "Delete planned change",
        "dateMustBeFuture": "Choose a date starting tomorrow",
        "duplicateDate": "A plan already exists for this date",
        "inactiveWarning": "This ad group is inactive. It won't be reactivated automatically.",
        "archivedWarning": "This ad group is archived. It won't be reactivated automatically.",
        "atLeastOneChange": "Set at least one cost, budget, or period field to change",
        "autoOpenForbidden": "Automatic daily budget cannot be combined with open budget capping",
        "previewCost": "Cost",
        "previewPeriod": "Period"
      }
    },
    "status": {
      "nobudgetleft": "No budget left",
      "startsoon": "Start soon",
      "ended": "Ended",
      "archived": "Archived",
      "activationWarning": {
        "nobudgetleft": "Will be automatically activated after increasing the budget",
        "startsoon": "Will be automatically activated on the start date",
        "ended": "Will be automatically activated after changing or deleting the end date",
        "archived": "Impossible to activate an archived AdGroup"
      }
    },
    "spentBudget": {
      "daySpent": "Spent today",
      "monthSpent": "Monthly spent",
      "overallSpent": "Overall spent",
      "periodSpent": "Period spent",
      "leftAmount": "({{left}} left)",
      "history": {
        "open": "View budget history",
        "title": "Budget history",
        "seriesToggleLabel": "Chart series",
        "costChartTitle": "Cost value per day ({{costType}})",
        "noCostChartData": "No cost value changes in this period.",
        "noChanges": "No date changes in this period.",
        "chartLegendCost": "{{label}}: {{value}} ({{costType}})",
        "chartLegendValue": "{{label}}: {{value}}",
        "chartLegendCapping": "{{label}}: {{value}} ({{type}})",
        "chartLegendTypeOnly": "{{label}}: {{type}}",
        "changedBy": "Changed by {{name}}"
      },
      "messageStatus": {
        "endDatePassed": "| Was stopped on {{endDate}}",
        "overSpent": "| No budget left since {{stoppedDate}}",
        "willStart": "| Will start on {{startDate}}",
        "willStopAtMonthly": "| Will stop on {{endDate}} & {{leftMonthBudget}} left this month",
        "willStopAtPeriod": "| Will stop on {{endDate}} & {{leftPeriodBudget}} left",
        "willStopAtOverall": "| Will stop on {{endDate}} & {{leftOverallBudget}} left",
        "willStop": "| Will stop on {{endDate}}",
        "budgetMonthly": "| {{leftMonthBudget}} left this month",
        "budgetPeriod": "| {{leftPeriodBudget}} left",
        "budgetOverall": "| {{leftOverallBudget}} left"
      },
      "warning": {
        "endDateSoon": "This adgroup will stop in {{daysThreshold}} days or less."
      }
    },
    "userCapping": {
      "title": "User Capping",
      "event": "event",
      "period": "Period",
      "value": "value",
      "noCapping": "No capping",
      "helperText": "Impressions = how many times people see your ad. Clicks = how many times people click your ad."
    },
    "userTargeting": {
      "autoSegments": {
        "noSegment": "No active auto segment",
        "title": "Auto Segments",
        "add": "Add an auto segments",
        "type": "Type",
        "dimension": "Dimension",
        "delete": "Delete this auto segment",
        "id": "Name",
        "duration": "Duration (day)",
        "isExcluded": "Included/Excluded",
        "dimensions": {
          "Advertiser": "Advertiser",
          "Publisher": "Publisher",
          "AdGroup": "AdGroup",
          "Website": "Website",
          "Campaign": "Campaign",
          "AdGroupIab": "AdGroup Iab",
          "PositionIab": "Position Iab"
        }
      },
      "tags": {
        "noTags": "No active tags",
        "title": "Tags",
        "add": "Add a tag",
        "delete": "Delete this tag",
        "origin": "Origin",
        "profileCount": "Number of profiles",
        "description": "Description",
        "isExcluded": "Included/Excluded"
      },
      "title": "User Targeting",
      "targetingGenderLabel": "Targeting gender",
      "targetingAgeLabel": "Targeting age",
      "gender": {
        "Male": "Male",
        "Female": "Female"
      },
      "targeting": "Targeting",
      "customAudienceLabel": "Custom audience",
      "customAudience": {
        "cdate": "Created date",
        "nbProfiles": "Number of profiles"
      },
      "noActiveSegments": "You haven't any active segments. ",
      "goToCampgaignSegments": "Go to campaign segments."
    },
    "deviceTypes": {
      "title": "Devices Types",
      "helperText": "Allows to target specific users *browsing* from specific devices and OS",
      "deviceTargetingLabel": "Device Targeting",
      "osTargetingLabel": "Os Targeting",
      "deviceType": {
        "Desktop": "Desktop",
        "Mobile": "Mobile",
        "Tablet": "Tablet"
      },
      "osType": {
        "Android": "Android",
        "Ios": "iOS",
        "Macos": "macOS",
        "Windows": "Windows"
      }
    },
    "geoTargeting": {
      "title": "GeoTargeting",
      "helperText": "By default the Ads are delivered on inventory from the Adgroup market. Users browsing from other countries might be targeted too. ",
      "rule": "Rule",
      "locationType": "Location type",
      "locationTypeHelper": "You can select only one type. If you change your selection will be erased.",
      "cities": "Cities",
      "departements": "Départements",
      "regions": "Regions",
      "countries": "Countries",
      "location": "Location(s)",
      "viewAllLocations_one": "View all locations ({{count}})",
      "viewAllLocations_other": "View all locations ({{count}})",
      "manageLocationsTitle": "Manage locations ({{count}})",
      "viewLocationsTitle": "All locations ({{count}})",
      "radiusDialogTitle": "Update radius of {{city}}",
      "marketCountry": "Your ads will be displayed on the {{countryCode}} market",
      "acceptedCountries": "Accepted contries",
      "allCountries": "All",
      "importCSV": "Import by CSV",
      "targetingAddresses": {
        "clearPrevious": "Remove previous GeoTargeting",
        "numberAddressesFound": "{{addressesFound}} addresses found",
        "radius": "Radius",
        "csvUploadInfoMessage": "Upload a CSV file containing a list of city names and/or postcodes. Each entry should be placed on a new line. You can have a mix of city names and postcodes.",
        "success": "The list of cities and postcodes has been imported",
        "unrecognizedCitiesMessage": "Some cities in the uploaded CSV file could not be found. Please review the list of unrecognized cities below, correct any errors or typos, and try uploading the file again:"
      },
      "panel": {
        "addToTargeting": "Add to targeting",
        "alreadyTargeted_one": "{{count}} already targeted, listed below",
        "alreadyTargeted_other": "{{count}} already targeted, listed below",
        "byType": "by",
        "clearAll": "Clear all",
        "clearAllConfirm_one": "Remove the {{count}} location from the targeting?",
        "clearAllConfirm_other": "Remove all {{count}} locations from the targeting?",
        "clearSearch": "Clear search",
        "columnCity": "City",
        "columnCodeRegion": "Code · Region",
        "columnCountry": "Country",
        "columnDepartement": "Département",
        "columnRadius": "Radius",
        "columnRegion": "Region",
        "decreaseRadius": "Decrease the radius of {{name}}",
        "deselectAll": "Deselect all",
        "empty": "No location targeted yet.",
        "enterToAdd": "Enter to add · Esc to close",
        "suggestionTargeted": "Already targeted",
        "excluded": "excluded",
        "increaseRadius": "Increase the radius of {{name}}",
        "matchCount": "{{shown}} of {{total}}",
        "noMatch": "No location matches “{{query}}”",
        "noNewPlace": "No new place matches “{{query}}”",
        "noneTargeted": "None targeted yet",
        "previewTitle": "New locations list (preview)",
        "radiusFor_one": "Radius for {{count}} selected location",
        "radiusFor_other": "Radius for {{count}} selected locations",
        "radiusValue": "{{radius}} km",
        "range": "{{from}}–{{to}} of {{count}}",
        "rangeMatching": "{{from}}–{{to}} of {{count}} matching",
        "regionCount_one": "from {{count}} region",
        "regionCount_other": "from {{count}} regions",
        "removeLocation": "Remove {{name}}",
        "removeSelected": "Remove",
        "removedMany_one": "Removed {{count}} location",
        "removedMany_other": "Removed {{count}} locations",
        "removedOne": "Removed {{name}}",
        "rowsPerPage": "Rows",
        "searchOnly_one": "Search {{count}} location",
        "searchOnly_other": "Search {{count}} locations",
        "searchOrAdd": "Search your locations or add a new one",
        "searchOrExclude": "Search excluded locations or exclude a new one",
        "selectAllMatching_one": "Select all {{count}}",
        "selectAllMatching_other": "Select all {{count}}",
        "selectLocation": "Select {{name}}",
        "selectPage": "Select this page",
        "selected_one": "{{count}} selected",
        "selected_other": "{{count}} selected",
        "setRadius": "Set radius",
        "targeted": "targeted",
        "undo": "Undo",
        "view": "View",
        "viewChips": "Chips",
        "viewTable": "Table"
      },
      "ruleHintInclude": "Ads are shown only in these locations.",
      "ruleHintExclude": "Ads are shown everywhere on the {{countryCode}} market, except in these locations."
    },
    "timeOfTheDay": {
      "title": "Time of the day",
      "helperText": "Allows to deliver Ads on selected days of the week and timeframes.",
      "daysOfTheWeekLabel": "Days of the week",
      "hoursOfTheDayLabel": "Hours of the day",
      "days": {
        "Monday": "Monday",
        "Tuesday": "Tuesday",
        "Wednesday": "Wednesday",
        "Thursday": "Thursday",
        "Friday": "Friday",
        "Saturday": "Saturday",
        "Sunday": "Sunday"
      }
    },
    "tabs": {
      "directory": "broadcast restriction",
      "bidAdjustments": "bid adjustments",
      "adPreview": "preview",
      "blacklist": "Blacklist",
      "dashboard": "dashboard",
      "settings": "settings"
    },
    "assistant": {
      "title": "AdGroup Assistant",
      "button": "Assistant",
      "showMeLater": "Show me later",
      "okForToday": "Ok for today",
      "recommendationsTitle": "Adgroup recommendations",
      "noRecommendations": "No recommendation available for now.",
      "noDataYet": "no data yet",
      "hideRule": "Hide rule",
      "showRule": "Show rule",
      "disableRule": "Disable rule",
      "enableRule": "Enable rule",
      "hidden": "Hidden",
      "showHiddenRules": "Show Hidden Rules",
      "hideHiddenRules": "Hide Hidden Rules",
      "ruleHidden": "Rule hidden successfully",
      "ruleHideFailed": "Failed to hide rule",
      "ruleShown": "Rule shown successfully",
      "ruleShowFailed": "Failed to show rule",
      "ruleDisabled": "Rule disabled successfully",
      "ruleDisableFailed": "Failed to disable rule",
      "ruleEnabled": "Rule enabled successfully",
      "ruleEnableFailed": "Failed to enable rule",
      "decisions": {
        "abTest": "A/B test",
        "continue": "Continue",
        "stop": "Stop"
      },
      "recommendations": {
        "abTest": "Run this creative in A/B test mode.",
        "continue": "Keep this creative active.",
        "stop": "Pause this creative."
      },
      "recommendationCodes": {
        "AdCopyMaxLifetimeExceeded": "One or more creatives have reached the maximum lifetime",
        "AdGroupNotEnoughAdCopiesForBudget": "The adgroup has not enough creatives for the budget",
        "AdGroupTooManyAdCopiesForBudget": "The adgroup has too many creatives for the budget",
        "AdGroupAdCopyReadyForNewAbTest": "The adgroup has an adcopy ready for a new A/B test",
        "AdGroupImbalancedAbTestImpressions": "The adgroup has an imbalanced A/B test impressions",
        "AdGroupIncreaseDailyBudgetForBudgetCapping": "The adgroup has a too low daily budget capping. Increase the daily budget or use automatic daily budget"
      },
      "table": {
        "adCopy": "Creative",
        "decision": "Decision",
        "recommendation": "Recommendation",
        "actions": "Actions",
        "startedAt": "Started at",
        "hiddenColumnsWarning": "The following columns are hidden because they have no data: {{columns}}",
        "lr": "LR",
        "cpl": "CPL",
        "or": "OR",
        "cpo": "CPO",
        "roi": "ROI"
      },
      "importance": {
        "high": "High",
        "medium": "Medium",
        "low": "Low"
      },
      "stepRecommendations": "Recommendations"
    },
    "bidAdjustments": {
      "title": "Bid adjustments",
      "byDeviceType": {
        "title": "By device type",
        "table": {
          "deviceType": "Device type",
          "wantedAdjustment": "Wanted adjustment",
          "adjustedDefaultCost": "Cost",
          "adjustment": "Adjustment"
        }
      },
      "byWebsite": {
        "confirmRemoveWebsite": "Are you sure you want to remove {{name}} website's adjustments ?",
        "title": "By website",
        "table": {
          "website": "Website",
          "url": "Url",
          "adjustment": "Adjustment",
          "wantedAdjustment": "Wanted adjustment",
          "calculateAdjustedDefaultCost": "Cost"
        },
        "searchInDirectory": {
          "title": "Publisher websites",
          "addWebsites": "Add adjustments"
        }
      },
      "costLimit": {
        "min": "The new calculated cost is below the minimum cost of {{minCostByType}}. The saved adjustment will be {{realAdjustment}}%.",
        "max": "The new calculated cost is above the maximum cost of {{maxCostByType}}. The saved adjustment will be {{realAdjustment}}%."
      },
      "costValueOutsideLimits": "The cost of this adGroup is outside the allowed limits. Please adjust the cost in settings to be between the minimum and maximum values."
    },
    "blacklistPage": {
      "description": "List of all websites where this adgroup cannot be displayed because the publisher has blacklisted it.",
      "trafficLost": "{{blacklistPercent}}% of traffic lost, {{finalPercent}}% of traffic remaining",
      "website": "Website",
      "publisher": "Publisher",
      "reseller": "Reseller",
      "reasons": "Reasons"
    },
    "directory": {
      "title": "Restriction preset",
      "updated": "The broadcast restriction list has been updated !",
      "cannotUpdateType": "You can update the restriction type only if there is no restriction yet",
      "addPosition": "Add positions",
      "presets": "Broadcast restriction presets",
      "presetInventory": "Broadcast restriction presets",
      "selectPresets": "Use a preset",
      "selectPresetsTitle": "Select broadcast restriction presets",
      "convertToPreset": "Convert to preset",
      "convertToPresetTitle": "Convert restriction list to preset",
      "parentCompany": "Parent company",
      "replaceWithPresetConfirm": "Replace the current restriction list with preset {{name}}?",
      "replaceWithPresetApplied": "Preset applied and restriction list cleared",
      "managePresets": "Manage broadcast restriction presets",
      "presetPreview": "{{websiteCount}} websites, {{positionCount}} positions",
      "searchDirectory": {
        "title": "Publisher websites",
        "saved": "Websites successfully added to the broadcast restriction",
        "positions": "Positions",
        "presets": "Broadcast restriction presets",
        "presetsSaved": "Broadcast restriction presets updated",
        "noPresets": "No broadcast restriction presets available"
      },
      "directoryList": {
        "reseller": "Reseller",
        "impressions": "Traffic"
      },
      "incompatibleCreativesPosition": "None of the active creatives can be served on this position.",
      "incompatibleCreativesWebsite": "Some positions on this website are not compatible with the active creatives.",
      "templateSizes": "Template sizes: {{sizes}}",
      "alert": {
        "veryLow": "This restriction list includes only {{ percent }}% of the available impressions, you should consider including more websites.",
        "low": "This restriction list includes only {{ percent }}% of the available impressions.",
        "default": "This restriction list includes {{ percent }}% of the available impressions."
      }
    },
    "adPreview": {
      "label": "Website and Ad Position",
      "info": "Select a position to display a preview",
      "channelTypeWarning": "Adgroup must have a channel type configured",
      "noPositions": "Impossible to make a preview, no positions available",
      "noActiveAdCopy": "No active creative on this adGroup.",
      "goToAdCopies": "Go to creatives page",
      "positionNotInDirectory": "The selected position is not compatible with this adGroup.",
      "adServerPreview": "Preview with AdServer",
      "preview": "AdCopy preview",
      "incompatibleAdCopies": "Incompatible AdCopies",
      "noCompatibleAdCopies": "No compatible AdCopies",
      "minRequiredWidth": "Minimum required width",
      "minRequiredHeight": "Minimum required height",
      "tooSmallBy": "{{label}} is too small by {{value}}px"
    },
    "duplicateStatusWarning": "The copy will be disabled. You  will need to activate it manually.",
    "analytics": {
      "import": "Add stats from analytics",
      "processingImport": "Processing import…",
      "rowsDetected": "{{rows}} lines",
      "description": "Upload a CSV file containing analytics content. Each entry should be placed on a new line. ",
      "dropCsvFile": "Drop your CSV file here",
      "dropCsvFileOr": "or",
      "success": "Imported successfully",
      "at": "Date",
      "adCopyId": "Creative",
      "pageViews": "Page views",
      "sessions": "Sessions",
      "engagedSessions": "Engaged Sessions",
      "totalUsers": "Total Users",
      "newUsers": "New Users",
      "bounceRate": "Bounce Rate",
      "engagementRate": "Engagement Rate",
      "sessionTimeSeconds": "Session time",
      "cpv": "CPV",
      "viewOriginalFile": "See original file",
      "originalFileTitle": "Original file: {{filename}}",
      "mapCreativesTooltip": "Match each imported creative name to a creative in this ad group",
      "mapCreativesTitle": "Map creatives",
      "mapCreativesDescription": "Choose which creative in the ad group corresponds to each name from your file.",
      "mapCreativesDecodeImportedNames": "URL decode names and replace + with spaces",
      "mapCreativesFilter": "Filter imported names",
      "mapCreativesFilterHelper": "Leave empty to include all names, or choose Ad*.",
      "mapCreativesFilterEmpty": "No imported creative names match this filter.",
      "mapCreativesImportedName": "Imported name",
      "mapCreativesMatchDoubleClickPlacementId": "Match double click placementID",
      "mapCreativesMatchUtmContent": "Match redirect utm_content",
      "mapCreativesMappedCount": "Mapped {{mapped}} / {{total}}",
      "mapCreativesRemoveStatusText": "Remove status text",
      "mapCreativesSelectedCreative": "Ad group creative",
      "mapCreativesSettings": "Matching settings",
      "mapCreativesEmpty": "No creative names were found in the imported data.",
      "showAllValues": "Show all",
      "atLeastOneCreativeMustBeImportable": "Map at least one imported creative with a valid date before importing.",
      "missingStartDateWarning": "The following creatives do not have a start date and were not split across the date range: {{adCopies}}.",
      "sourceColumn": "Column",
      "sourceColumns": "Columns",
      "mappingMode": "Mapping mode",
      "calculation": "Calculation",
      "formulaHelp": "For stats columns, choose one or more columns from the file or build a calculation using file columns.",
      "formulaInsertColumn": "Insert column",
      "formulaExpression": "Calculation",
      "formulaPlaceholder": "Build a calculation from file columns",
      "formulaBuilderHelp": "Click file columns above to insert them, then edit the calculation as needed.",
      "formulaClear": "Clear calculation",
      "formulaCreate": "Create calculation",
      "formulaEdit": "Edit calculation",
      "formulaModalHint": "Open the builder to choose columns and preview results.",
      "formulaTooltipHint": "Hover to see the current calculation.",
      "formulaBuilderTitle": "Calculation for {{field}}",
      "formulaModalDescription": "Build the calculation by inserting columns from the uploaded file. The examples below use the first rows of the file.",
      "formulaPreviewTitle": "Example results",
      "formulaRow": "Row",
      "formulaSampleValues": "Sample values",
      "formulaResult": "Result",
      "formulaError": {
        "emptyExpression": "the calculation is empty",
        "unknownHeader": "unknown column",
        "ambiguousHeader": "ambiguous column name",
        "invalidSyntax": "invalid calculation",
        "divisionByZero": "division by zero"
      },
      "allCreativesMustBeMapped_one": "Map every imported creative to a creative in this ad group before importing. 1 unmapped creative will be skipped.",
      "allCreativesMustBeMapped_other": "Map every imported creative to a creative in this ad group before importing. {{count}} unmapped creatives will be skipped.",
      "showMappedValues_one": "Unmapped (1)",
      "showMappedValues_other": "Unmapped ({{count}})",
      "mapCreatives_one": "Map creatives (1)",
      "mapCreatives_other": "Map creatives ({{count}})",
      "formulaErrors_one": "1 calculation error: {{errors}}",
      "formulaErrors_other": "{{count}} calculation errors: {{errors}}"
    },
    "reach": {
      "veryLow": "This adgroup includes only {{ percent }}% of the available impressions, you should consider including more websites.",
      "low": "This adgroup includes only {{ percent }}% of the available impressions.",
      "default": "This adgroup includes {{ percent }}% of the available impressions.",
      "info": "This information does not include geotargeting and segments.",
      "recommendedCpc": "Recommended CPC:"
    },
    "debug": {
      "title": "AdGroup Debug"
    },
    "rulesExceptionsSummary_one": "{{count}} accepted country",
    "rulesExceptionsSummary_other": "{{count}} accepted countries",
    "rulesExceptionsOff": "off"
  },
  "campaign": {
    "sectionTitle": "Campaign Summary",
    "advertiserDomainName": "Advertiser Domain Name",
    "name": "Campaign Name",
    "adGroupTaxonomy": {
      "title": "Ad groups and their taxonomy",
      "view": "Check AdGroups taxonomy",
      "taxonomy": "Taxonomy"
    },
    "create": "Create New Campaign",
    "created": "New Campaign Created !",
    "updated": "Your Campaign has been updated !",
    "goToCampaign": "Go to {{campaignName}}",
    "adgroupsHelper": "Optionally add ad groups to the new campaign. You can add several before finishing creation.",
    "copperOpportunity": "Copper opportunity",
    "copperOpportunityStage": "Copper opportunity stage",
    "copperOpportunityBudgetRemaining": "{{amount}} of the selected opportunity budget is not yet allocated to ad groups.",
    "spentBudget": {
      "messageStatus": {
        "leftBeforeDate": "| {{leftBudget}} left before {{endDate}}",
        "leftThisMonth": "| {{leftBudget}} left this month",
        "left": "| {{leftBudget}} left"
      },
      "tooltip": {
        "monthly": "{{name}} — {{leftBudget}} left this month",
        "period": "{{name}} — {{leftBudget}} left this period",
        "overall": "{{name}} — {{leftBudget}} left overall",
        "open": "{{name}} — no limit"
      },
      "warning": {
        "endDateSoon": "This campaign will stop in {{daysThreshold}} days or less.",
        "endOfMonthSoon": "The monthly budget will reset in {{daysThreshold}} days or less."
      }
    },
    "details": {
      "adGroups": "AdGroups",
      "advertiserDomainName": "Advertiser Domain Name",
      "companyName": "Company",
      "marketCode": "Market",
      "resellerName": "Reseller",
      "domainName": "Domain",
      "type": "Type",
      "stepperTitle": "Campaign details",
      "iabCategory": "IAB Category"
    },
    "analytics": {
      "sessions": "Sessions",
      "session": "Session",
      "landing": "Landing",
      "lead": "Lead",
      "leadId": "Lead Id",
      "orderId": "Order Id",
      "order": "Order",
      "iframe": "Iframe",
      "image": "Image",
      "tracking": {
        "title": "Javascript Tag",
        "tagVersions": "Tag Versions",
        "confirmationTags": "Confirmation Tags",
        "sessionTags": "Session Tags",
        "confirmationWarning": "A Session or Landing Tag must already have been placed on your ad redirect page beforehand in order to place a Confirmation Tag.",
        "mainWarning": "Please use only one of our Tags per page.",
        "additionalLeadWarning": "Don't forget to add your internal Lead Id value in the {lead-id}.",
        "additionalOrderWarning": "Don't forget to add your internal Order Id value in the {order-id}, your order value in the {order-value}, and the currency if it's not EUR.",
        "lead": "Tracking code to add on your Lead confirmation page.",
        "order": "Tracking code to add on your Order confirmation page.",
        "replaceUnique": "must be replaced by a unique",
        "replace": "must be replaced by the",
        "orderAmount": "amount of the order",
        "orderAmountSeparator": "with a \".\" as decimal separator.",
        "orderCurrency": "currency of the order",
        "orderCurrencyExample": "\"EUR\" for euros (€), \"USD\" for us dollars ($).",
        "cspWarning": "If your website uses a Content Security Policy (CSP), make sure to allow *.powerspace.com and *.pwspace.com in the script-src directive.",
        "cookiesUsed": "This tag uses the following cookies to work properly. They store anonymous technical information that allows us to measure sessions and conversions accurately. It is not possible to track leads or orders without these cookies.",
        "cookieName": "Cookie Name",
        "cookiePurpose": "Purpose",
        "cookieRetention": "Retention",
        "sendPageViews": "Send page views",
        "cookies": {
          "pwqci": {
            "purpose": "Click ID - stores the click identifier from redirect url to detect the lead or order",
            "retention": "30 days"
          },
          "pstuid": {
            "purpose": "Powerspace Tracking User ID - unique user identifier",
            "retention": "30 minutes"
          },
          "pwpv": {
            "purpose": "Page View - stores encrypted analytics URL with session/pageview data",
            "retention": "30 minutes"
          }
        }
      },
      "serverTracking": {
        "title": "Server to Server",
        "mainWarning": "Please provide additional information.",
        "fullWarning": "You should replace the {clickId} by the value found in your url after the redirection from Powerspace.",
        "parameters": {
          "clickId": {
            "description": "The click identifier from the redirect URL to detect the lead or order. You should replace the {clickId} by the value found in your url after the redirection from Powerspace."
          },
          "orderValue": {
            "description": "The amount of the order with \".\" as decimal separator."
          }
        },
        "headers": {
          "parameter": "Parameter",
          "description": "Description",
          "required": "Required"
        }
      },
      "standardTracking": {
        "title": "Standard Tracking Tags (deprecated)"
      },
      "attributionSettings": {
        "title": "Attribution Settings",
        "subtitle": "Post Click Attribution Settings",
        "confirmDialogTitle": "Are you sure ?",
        "confirmDialogMessage": "Changing this setting will affect the Tracking and less Conversions might appear in the Reports"
      }
    },
    "edit": {
      "sectionTitle": "Modify Campaign"
    },
    "segments": {
      "createdSuccess": "New segment created !",
      "updatedSuccess": "Segment updated !",
      "Created": "Created",
      "Processed": "Processed",
      "Processing": "Processing",
      "Error": "Error",
      "Deleting": "Deleting",
      "profiles": "profiles",
      "errors": {
        "UnsufficientValidLines": "insufficient valid lines"
      },
      "nbProfilesInfo": "This segment contains {{nbProfiles}} profiles",
      "reachInfo": "Reach: {{reach}}%",
      "email": {
        "title": "Email Segments",
        "lastModified": "Last Modification Date",
        "originalFilename": "Original Filename",
        "uploadFile": "Upload New File",
        "formatInfo": "Emails contained in the file must be in lowercase letters before upload.",
        "sampleFile": "You can download a sample file",
        "fileType": ".csv or .txt accepted. Min 50 lines with 1 email per line",
        "modal": {
          "title": "Manage Segment",
          "deleteTitle": "Delete Email Segment confirmation",
          "delete": "You are about to delete segment {{segmentName}}. \nAre you sure you want to proceed ?"
        }
      },
      "behavioural": {
        "title": "Behavioural Segments",
        "manage": "Manage behavioural segment",
        "newSegment": "Create New Segment",
        "lastModified": "Last Modification Date",
        "duration": "Duration",
        "modal": {
          "title": "Create Segment",
          "target": "I want to target people",
          "past": "In the past",
          "addRule": "Add rule",
          "oneRuleMini": "At least one rule is needed",
          "delete": "Remove segment"
        }
      },
      "rules": {
        "VisitedWebsite": "who visited a website",
        "VisitedUrl": "who visited a specific URL",
        "NotVisitedUrl": "who did not visit a specific URL",
        "VisitedUrlContaining": "who visited a URL containing",
        "NotVisitedUrlContaining": "who did not visit a URL containing"
      },
      "Profiles": "profiles"
    },
    "statusWarning": "The campaign {{name}} is stopped.",
    "tabs": {
      "events": "Analytics & Tracking",
      "segments": "Segments",
      "dashboard": "Dashboard"
    },
    "segment": {
      "deleted": "Segment has been deleted"
    }
  },
  "adcopy": {
    "archived": "Your creative has been archived !",
    "addVariation": "Add Variation",
    "create": "Add a creative",
    "update": "Update this creative",
    "duplicate": "Duplicate this creative",
    "duplicateInsteadOfUpdatePrefix": "To compare performance more accurately, we recommend",
    "duplicateInsteadOfUpdateLink": "duplicating this creative",
    "duplicateInsteadOfUpdateSuffix": "instead of modifying it.",
    "created": "Your creative has been created !",
    "updated": "Your creative has been updated !",
    "updateWarning": "Changes will be enabled in maximum {{minutesNumber}} minutes",
    "settingsStep": "Settings",
    "forceRedirectUrl": "URL redirect",
    "impressionPixels": "Impression pixels",
    "redirectUrl": "Redirect URL",
    "comments": "Comments",
    "advertiserName": "Advertiser Name",
    "callToAction": "Call to Action",
    "copyWriting": "Creative",
    "creationMode": "Creation mode",
    "creationModeShuffle": "Shuffle",
    "creationModeList": "List",
    "createVariantsInfo": "You can create up to {{max}} variants of your creative by clicking 'add variation' on available fields.",
    "abtestSelected": "Make an A/B test with this creative",
    "abTestWizardTitle": "A/B test this creative",
    "sameImageReused": "This variant will reuse the original image from the selected creative.",
    "abTestExpectedFive": "Exactly 5 contents are required (original + 4 variants).",
    "abTestTwoImagesRequired": "Please provide 2 new images for variants 4 and 5.",
    "totalGeneratedAdCopies": "Total of {{number}} Creative(s)",
    "cropImage": "Crop image",
    "chooseImage": "Choose image",
    "chooseImages": "Choose image(s)",
    "availableSize": "Available size are :",
    "image": "Image",
    "idealSize": "Ideal size is 1200 x 628 (width x height)",
    "widthAndHeight": "(width x height)",
    "noImage": "No image",
    "cropNeeded": "Before saving you need to crop your picture in order to get the correct ratio",
    "cropCloseWarning": "Closing now will cancel cropping and delete this image. You can keep editing to crop and save it.",
    "sizeLimit": "Image size limit is 2mb",
    "sizeMiniError": "Image does not meet the minimum size requirement.",
    "sizeMiniInfo": "Minimum size is {{minWidth}} x {{minHeight}} (width x height)",
    "sizeMiniWarning": "Warning: the selected image size is below the recommended minimum. The image will be resized, which may result in a reduction of quality.",
    "imageCropperError": "Image cropper error, please retry or contact support",
    "archiveConfirmation": "Do you really want to archive {{adCopyName}} ?",
    "cannotArchived": "You are not authorized to archived this AdCopy because it's the only one active",
    "badResolution": "Image resolution is invalid",
    "adGroupOverride": "Adgroup Override",
    "adGroupOverrideTooltip": "Specific option for this adcopy, by default theses informations are the same than the adgroup",
    "previewTable": {
      "title": "Creatives",
      "name": "Name and preview",
      "weight": "Diffusion weight",
      "schedule": "Schedule",
      "scheduleFrom": "From {{date}}",
      "scheduleUntil": "Until {{date}}",
      "scheduleRange": "{{startDate}} → {{endDate}}",
      "duplicateDialogTitle": "Creative duplication",
      "duplicateConfirmation": "Would you like to duplicate {{adCopyName}} ?",
      "createdAt": "Creation date",
      "updatedAt": "Last change",
      "visualUpdatedAt": "Last visual change",
      "dates": "Dates",
      "dateCreatedRelative": "Created {{relative}}",
      "dateUpdatedRelative": "Updated {{relative}}",
      "dateTooltipSame": "Created and last visual change: {{date}}",
      "dateTooltipCreated": "Created: {{date}}",
      "dateTooltipVisualUpdated": "Last visual change: {{date}}",
      "since": "since",
      "errorStatusTooltip": "There is an error with the current image. Please convert it to JPG (renaming the file extension is not enough) and upload it again."
    },
    "archivedFilter": {
      "label": "Status",
      "allStatus": "All status",
      "archived": "Archived"
    },
    "wizzard": {
      "max": "Max {{max}} characters - {{length}}/{{max}}",
      "betweenMinMax": "Should be between {{min}} and {{max}} characters - {{length}}/{{max}}"
    },
    "dates": {
      "notToday": "No active creative today",
      "startDateAndEndDateError": "This adgroup can only start on {{startDate}} and will be ended on {{endDate}}",
      "startDateError": "Only creative with future start date are active, this adgroup can only start on {{startDate}}",
      "endDatesError": "Only creative with end date are active, this adgroup will be stopped because not creative will be active after the {{endDate}}"
    },
    "containsText": "The selected image contains text. We recommend using images without text for better performance.",
    "keywordSuggestions": "Keyword suggestions",
    "noKeywordSuggestions": "No keyword suggestions",
    "assistant": {
      "button": "Ai Assistant",
      "title": "AI assistant",
      "refresh": "Refresh",
      "remaining": "{{count}} slots available",
      "noSuggestions": "No suggestion available.",
      "add": "Add to variations",
      "addAll": "Add all suggestions"
    },
    "statusManager": {
      "step1": "View Recommendations",
      "stepBudgets": "Budgets",
      "step2": "Update Current Ad Copies",
      "stepAddNew": "Add New Ad Copies",
      "stepOverview": "Overview & Save",
      "budgetsStepTitle": "Adgroup Budgets",
      "action_adcopies": "Manage Active Ad Copies Status",
      "noActiveAdCopies": "No active ad copies found",
      "recommended": "Recommended",
      "display": {
        "cards": "Cards",
        "table": "Table"
      },
      "createNew": "Create New Content",
      "overviewStepTitle": "Overview before save",
      "overviewBudgets": "Budgets",
      "overviewRuleBudgets": "Rule-based Budget Changes",
      "overviewStatuses": "Active ad copies",
      "overviewNewAdCopies": "New ad copies to create",
      "overviewAdGroupChanges": "Budget Settings",
      "overviewDemographicsChanges": "Demographics Targeting",
      "overviewGeoTargetingChanges": "Geographic Targeting",
      "overviewDeviceOsChanges": "Device & OS Targeting",
      "overviewTimeTargetingChanges": "Time Targeting",
      "overviewStatusUpdates": "Ad Copy Status Updates",
      "stepNoChanges": "No changes",
      "statusWillChange": "Status will be updated",
      "noStatusChanges": "No status change",
      "noChanges": "No changes",
      "noRecommendation": "Everything is OK, no recommendation for now.",
      "partialSave": "Some changes were saved. Errors: {{errors}}",
      "saveFailed": "No change saved. Errors: {{errors}}",
      "saved": "All changes were saved successfully",
      "action": {
        "action_budget": "Budget Settings",
        "action_demographics": "Demographics Targeting",
        "action_geoTargeting": "Geographic Targeting",
        "action_deviceOs": "Device & OS Targeting",
        "action_timeTargeting": "Time Targeting",
        "action_adcopies": "Update Current Ad Copies"
      },
      "pendingIntegration": {
        "demographics": "Demographics targeting form integration is pending. This step will allow you to modify gender and age range targeting based on rule recommendations.",
        "geoTargeting": "Geographic targeting form integration is pending. This step will allow you to modify country, city, and region targeting based on rule recommendations.",
        "deviceOs": "Device and OS targeting form integration is pending. This step will allow you to modify device type and operating system targeting based on rule recommendations.",
        "timeTargeting": "Time targeting form integration is pending. This step will allow you to modify day and hour targeting based on rule recommendations."
      }
    },
    "deleted": "Your creative has been deleted!"
  },
  "adTemplate": {
    "Native": "Native",
    "Banner": "Banner",
    "Web": "Web",
    "notFound": "Template not found",
    "size": "Size",
    "edit": "Edit template",
    "update": "Update a template",
    "updateWarning": "Changes will be enabled in maximum {{minutesNumber}} minutes",
    "duplicate": "Duplicate this template",
    "duplicateConfirmation": "Would you like to duplicate {{adTemplateName}} ?",
    "deleteConfirmation": "Do you really want to delete {{adTemplateName}} ?",
    "cannotDeleteAdTemplate": "You are not authorized to delete this template because it's the only one active on this position",
    "created": "Your template has been created !",
    "duplicated": "Your template has been duplicated !",
    "deleted": "Your template has been deleted !",
    "updated": "Your template has been updated !",
    "table": {
      "format": "Format"
    },
    "web": {
      "cssSelector": "CSS selector",
      "cssSelectorPosition": "CSS selector position",
      "preview": "Template Preview",
      "editor": "Template web editor",
      "masterTemplate": "Master",
      "zoneTemplate": "Zone",
      "js": "Javascript",
      "css": "Css",
      "beautify": "Format the code"
    },
    "preview": {
      "desktopPreview": "Desktop preview",
      "mobilePreview": "Mobile preview",
      "failed": "Error: couldn't load preview",
      "reload": "Reload image(s)"
    },
    "create": {
      "title": "Create a template"
    },
    "NotFound": "Template not found",
    "unknownFormat": "This kind of template is not currently handled by the platform"
  },
  "commons": {
    "accessType": "Access Type",
    "conversions": "Conversions",
    "priority": "Priority",
    "actions": {
      "add": "Add",
      "confirm": "Confirm",
      "confirmTheAction": "Confirm the action",
      "confirmDuplicate": "Are you sure you want to duplicate {{name}} ?",
      "confirmArchive": "Do you really want to archive {{name}} ?",
      "cancel": "Cancel",
      "close": "Close",
      "changePassword": "Change password",
      "create": "Create",
      "delete": "Delete",
      "downloadAsCsv": "Download as CSV",
      "archive": "Archive",
      "back": "Back",
      "duplicate": "Duplicate",
      "hoverEditHelper": "Click on below buttons to activate/deactivate item",
      "edit": "Edit",
      "filter": "Filter",
      "moreOptions": "More options",
      "save": "Save",
      "selectAll": "Select All",
      "deselectAll": "Deselect All",
      "activate": "Activate",
      "disable": "Disable",
      "reject": "Reject",
      "quitWithoutSaving": "Quit without saving",
      "selectFile": "Select a file",
      "showMore": "Show more",
      "showLess": "Show less",
      "exportToXlsx": "Export to Excel file"
    },
    "sort": "Sort",
    "actionsTitle": "Actions",
    "activityfeed": "Activity Feed",
    "autoReload": {
      "label": "Auto-reload",
      "off": "Off"
    },
    "adgroup": "Adgroup",
    "adgroups": "Ad Groups",
    "admin": "Admin",
    "adTemplates": "Templates",
    "all": "all",
    "active": "Active",
    "inactive": "Inactive",
    "paused": "Paused",
    "pending": "Pending",
    "nobudgetleft": "No budget left",
    "pendingvalidation": "Pending validation",
    "rejected": "Rejected",
    "processing": "Processing",
    "waiting": "Waiting",
    "archived": "Archived",
    "ended": "Ended",
    "startsoon": "Start soon",
    "campaign": "Campaign",
    "campaigns": "Campaigns",
    "companies": "Companies",
    "companyName": "Company",
    "create": "Create",
    "creative": "Creative",
    "comingSoon": "This feature will be available soon",
    "days": "Days",
    "default": "Default",
    "details": "Details",
    "desktop": "Desktop",
    "deleted": "Deleted",
    "disabled": "Disabled",
    "domainFormatError": "Please verify your domain is properly formatted",
    "email": "Email",
    "emptyData": "No data was found",
    "emptyField": "None",
    "entityType": "Entity Type",
    "enabled": "Enabled",
    "error": "Error",
    "errorOccurred": "An error occured",
    "exclude": "exclude",
    "firstName": "Firstname",
    "fullName": "Name",
    "format": "format",
    "goTo": "Go to {{item}}",
    "iabCategory": "IAB Category",
    "recommendedIabCategoryAlert": "Recommended IAB category: {{category}}",
    "id": "ID",
    "include": "include",
    "integer": "Value should be an integer",
    "invited": "Invited",
    "invalidUrl": "Invalid URL",
    "urlCheck": {
      "redirectsTo": "This URL redirects to {{url}}",
      "redirectDetected": "This URL redirects elsewhere (destination could not be read)",
      "httpError": "URL check failed with HTTP status {{status}}",
      "expiredCertificate": "URL could not be checked because the site's SSL certificate has expired",
      "requestFailed": "URL could not be checked (network error or blocked by the browser)"
    },
    "lastName": "Lastname",
    "login": "Login",
    "manager": "Manager",
    "market": "Market",
    "mobile": "Mobile",
    "modified": "Modified",
    "nonArchived": "Non archived",
    "saved": "Your changes have been saved",
    "savedWithDelay": "Changes will be enabled in maximum {{minutesNumber}} minutes",
    "name": "Name",
    "noValueYet": "No value yet",
    "no": "No",
    "noDataToDisplay": "Nothing selected yet",
    "password": "Password",
    "publishers": "Publishers",
    "phone": "Phone",
    "primaryContact": "Primary contact",
    "pageNumber": "Page n°{{currentPage}}",
    "reports": "Reports",
    "reseller": "Reseller",
    "required": "Required field",
    "retry": "Retry",
    "rowsPerPage": "rows per page",
    "startDate": "Start date",
    "endDate": "End date",
    "settingsTitle": "Settings",
    "paginationDisplayedRows_one": "{{from}}–{{to}} of 1",
    "paginationDisplayedRows_other": "{{from}}–{{to}} of {{count}}",
    "atLeastOneOption": "Select at least one option",
    "budget": "Budget",
    "status": "Status",
    "derivedStatus": {
      "adGroups": "This status only reflects the ad groups status. It is active when at least one ad group is active. To deactivate it, deactivate all ad groups.",
      "positions": "This status only reflects the positions status. It is active when at least one position is active. To deactivate it, deactivate all positions."
    },
    "dashboard": "dashboard",
    "settings": "settings",
    "stepper": {
      "back": "Back",
      "next": "Next",
      "skip": "Skip",
      "submit": "Submit",
      "submitting": "Submitting",
      "checkRecommendations": "Check these recommendations"
    },
    "title": "Title",
    "description": "Description",
    "tooltips": {
      "limitExceeded": "other element(s)"
    },
    "unknown": "Unknown",
    "unsavedModifications": "Fields with unsaved modifications :",
    "unsavedChangesWarning": "Are you sure you want to leave this page without saving ?",
    "closeDialogWithoutSaving": "Are you sure you want to close this dialog without saving ?",
    "user": "user",
    "users": "Users",
    "websites": "Websites",
    "hour": "Hour",
    "day": "Day",
    "week": "Week",
    "month": "Month",
    "year": "Year",
    "yes": "Yes",
    "endDateValidation": "End date can't be before start date",
    "validation": {
      "minWithCount": "{{name}} must be at least {{min}} characters - {{length}}/{{max}}",
      "maxWithCount": "{{name}} must be at most {{max}} characters - {{length}}/{{max}}",
      "numberMin": "must be greater than or equal to {{min}}",
      "numberMax": "must be less than or equal to {{max}}"
    },
    "noDataAvailable": "No data available",
    "errors": {
      "generic": "An error occurred"
    },
    "revenue": "Revenue",
    "ctr": "CTR",
    "cpm": "CPM",
    "clicks": "Clicks",
    "impressions": "Impressions",
    "leads": "Leads",
    "orders": "Orders",
    "costs": "Costs",
    "adcopies": "creatives",
    "toolbar": {
      "selectedCount_one": "{{count}} selected",
      "selectedCount_other": "{{count}} selected"
    }
  },
  "company": {
    "billing": {
      "bankDetails": "Bank details",
      "bankName": "Bank Name",
      "currency": "Default currency",
      "edit": {
        "title": "Billing details edition"
      },
      "iban": "IBAN",
      "invoiceLanguage": "Invoice language",
      "invoiceSettings": "Invoice settings",
      "invoicingCompany": "Billing Entity",
      "paymentTerm": "Payment terms",
      "sectionTitle": "Billing",
      "stepperTitle": "Billing details",
      "swift": "SWIFT / BIC"
    },
    "billingContacts": {
      "createDialogTitle": "Create billing contact",
      "created": "The billing contact has been properly created",
      "deleteConfirm": "You are about to delete the following billing contact : {{firstName}} {{lastName}}. \nAre you sure you want to proceed ?",
      "deleteDialogTitle": "Delete billing contact confirmation",
      "helperTooltip": "Additionnal contacts for billing/invoice notifications",
      "sectionTitle": "Billing contacts"
    },
    "cgu": {
      "accept": "Accept",
      "accepted": "Accepted",
      "acceptCguMessage": "To continue using the application, you need to accept our Terms and Conditions.",
      "inherited": {
        "agency": "These terms are managed by the parent agency.",
        "agencyOrReseller": "These terms are managed by the parent agency or reseller.",
        "link": "Check them there.",
        "reseller": "These terms are managed by the parent reseller."
      },
      "newCguVersionMessage": "Our Terms and Conditions have been updated. Please read the new version and accept it to continue using our services.",
      "notAccepted": "Not accepted yet"
    },
    "create": "Create Company",
    "created": "The company was properly created",
    "usersHelper": "Optionally add users to the new company. You can add several before finishing creation.",
    "details": {
      "accountingId": "Accounting ID",
      "address": "Address",
      "city": "City",
      "companyType": "Company Type",
      "contact": "Contact",
      "copperOpportunity": "Opportunity",
      "copperOpportunityStage": "Copper opportunity stage",
      "country": "Country",
      "edit": {
        "title": "Business details edition",
        "vatHelper": "VAT Id is validated according to the country"
      },
      "fax": "Fax",
      "nameAndGeneric": "Name (Generic name)",
      "genericName": "Generic name",
      "map": "Map",
      "name": "Company Name",
      "nameAlreadyExists": "A company with this name already exists",
      "phone": "Phone",
      "agency": "Agency",
      "reseller": "Reseller",
      "resellerId": "Reseller",
      "resellerName": "Reseller",
      "sectionTitle": "Business details",
      "slug": "Company subdomain",
      "stepperTitle": "Company Details",
      "taxDetails": "Tax Details",
      "taxId": "Tax ID",
      "type": "Type",
      "vatId": "VAT ID",
      "website": "Website",
      "zipCode": "Zipcode"
    },
    "managers": {
      "accountManager": "Account Manager",
      "salesManager": "Sales Manager",
      "stepperTitle": "Managers"
    },
    "rights": {
      "api": "Api",
      "web": "Web channel",
      "adgroupCpm": "CPM",
      "adgroupCpl": "CPL",
      "adgroupCpc": "CPC",
      "adgroupExclusions": "Broadcast restriction",
      "adgroupCustomcpcs": "Bid adjustments",
      "adgroupReportwebsites": "View report by website",
      "adgroupUsertargeting": "Demographic targeting",
      "adgroupGeotargeting": "Geographic targeting",
      "adgroupDevicetargeting": "Device targeting",
      "adgroupTimetargeting": "Hour and day targeting",
      "adgroupPriority": "AdGroup Priority",
      "adgroupMonthlyBudgetCapping": "Monthly",
      "adgroupOverallBudgetCapping": "Overall",
      "adgroupOpenBudgetCapping": "Open",
      "adgroupPeriodBudgetCapping": "Period",
      "adgroupBudgetCapping": "Budget capping",
      "adgroupOpenDailyBudget": "Open daily budget",
      "adgroupDatesRequired": "Required start and end dates",
      "costSettings": "Cost settings",
      "budgetCappingSettings": "Budget capping settings",
      "disabledRequiresBudgetCapping": "Turn on budget capping to change this permission.",
      "adgroupSegments": "Segments CRM",
      "adgroupAutoSegments": "Auto-segments",
      "adCopyDates": "AdCopy Dates",
      "positionAdvancedsettings": "Position's advanced settings (CPM Floor, Rev. share)",
      "websiteExclusions": "Websites Campaigns Exclusions",
      "advertiserDirectoryPresets": "Directory presets",
      "publisherBlacklistPresets": "Blacklist presets",
      "description": {
        "api": "View api token and routes page",
        "web": "Display of the web channel",
        "banner": "Display of the banner template",
        "adgroupCpm": "Display of the CPM cost",
        "adgroupCpl": "Display of the CPL cost",
        "adgroupExclusions": "Display of the broadcast restriction page or targeting of websites and positions for AdGroups",
        "adgroupCustomcpcs": "Display the page to add custom bid adjustements by website, device or iab category",
        "adgroupReportwebsites": "Page of AdGroup statistics by website visible.",
        "adgroupUsertargeting": "Display of demographic targeting visible.",
        "adgroupGeotargeting": "Display of geographic targeting visible.",
        "adgroupDevicetargeting": "Display of device targeting visible.",
        "adgroupTimetargeting": "Display of hour and day targeting visible.",
        "adgroupPriority": "Allows this reseller to prioritize its ads before Powerspace.",
        "adgroupMonthlyBudgetCapping": "Allow monthly budget capping on ad groups.",
        "adgroupOverallBudgetCapping": "Allow overall budget capping on ad groups.",
        "adgroupOpenBudgetCapping": "Allow open (unlimited) budget capping on ad groups.",
        "adgroupBudgetCapping": "Allow budget capping type and amount on ad groups.",
        "adgroupOpenDailyBudget": "Allow open daily budget on ad groups.",
        "adgroupDatesRequired": "Require start and end dates on ad groups.",
        "costSettings": "Allowed cost types for ad groups. CPC is always enabled; CPM and CPL can be toggled.",
        "budgetCappingSettings": "Allowed budget capping types for ad groups. Period is always enabled; monthly, overall, and open can be toggled.",
        "adgroupSegments": "Page of CRM segments visible.",
        "adgroupAutoSegments": "Auto-segments visible in adgroups.",
        "adCopyDates": "Enable usage of the AdCopy start and end dates.",
        "positionAdvancedsettings": "Page of position's advanced settings (CPM Floor, Rev. share) visible.",
        "websiteExclusions": "Display of the page of websites exclusions.",
        "advertiserDirectoryPresets": "Create and manage advertiser directory presets.",
        "publisherBlacklistPresets": "Create, assign, and convert publisher blacklist presets."
      },
      "admin": "Admin",
      "edit": "Edit",
      "read": "Read",
      "banner": "Banner template",
      "sectionTitle": "Access and rights",
      "uiRightsMainTitle": "Main Access",
      "uiRightsTitle": "Access and rights",
      "groups": {
        "adCopy": "AdCopy",
        "position": "Position",
        "website": "Website",
        "presets": "Presets",
        "apiAccess": "API",
        "channels": "Channels",
        "budget": "Budget",
        "targeting": "Targeting",
        "segments": "Segments",
        "broadcast": "Broadcast and bidding",
        "priority": "Priority"
      },
      "inherited": {
        "agency": "These rights are managed by the parent agency. Check them there.",
        "reseller": "These rights are managed by the parent reseller. Check them there.",
        "agencyOrReseller": "These rights are managed by the parent agency or reseller. Check them there.",
        "generic": "These rights cannot be changed here."
      },
      "presets": {
        "label": "Rights preset",
        "title": "Rights presets",
        "description": "Apply a predefined set of advertiser permissions. Changes update the form only until you save.",
        "self": "Self",
        "managed": "Managed",
        "all": "All"
      }
    },
    "users": {
      "accessType": "Access Type",
      "actions": "Actions",
      "createUser": "Create user",
      "created": "The user was properly created",
      "deleted": "The user was deleted",
      "deleteConfirm": "You are about to permanently delete the following user: {{firstName}} {{lastName}}\nAre you sure you want to proceed ?\n\nOnce deleted, all contact and login information about this user be deleted.",
      "deleteDialogTitle": "Delete user confirmation",
      "edit": {
        "form": {
          "changePassword": "Change password",
          "passwordUpdated": "Your password was updated",
          "errors": {
            "digit": "One digit",
            "lowercase": "One lower case",
            "max": "Maximum {{max}} characters",
            "min": "Minimum {{min}} characters",
            "special": "One special character",
            "uppercase": "One upper case"
          },
          "newPassword": "New password",
          "passwordSecure": "Your password is secure !",
          "passwordBestPractices": {
            "title": "Password best practices",
            "passphrase": "Use a long passphrase made of several unrelated words.",
            "reuse": "Do not reuse a password that you use on other sites.",
            "personalInfo": "Avoid personal information such as your name, company or email address.",
            "passwordManager": "Consider a password manager to generate and store your passwords."
          }
        },
        "title": "Edit user"
      },
      "email": "Email",
      "emailAlreadyUsed": "This email is already used",
      "externalAccess": {
        "agency": "Agency",
        "revokeAccess": "Revoke Access",
        "title": "External Access"
      },
      "firstName": "Name",
      "invite": "Invite user",
      "invited": "User has been invited",
      "sendInvitation": "Send invitation",
      "isAdmin": "Admin",
      "jobTitle": "Job title",
      "lastName": "Last Name",
      "language": "Language",
      "languages": {
        "en": "English",
        "fr": "French",
        "it": "Italian"
      },
      "mobile": "Phone",
      "passwordValidation": "Password Validation",
      "primaryContact": "Primary contact",
      "primaryContactYes": "Yes",
      "primaryContactNo": "No",
      "sectionTitle": "User",
      "stepperTitle": "Users",
      "userInfos": "User infos",
      "preferences": "Preferences",
      "market": "Default Market",
      "roles": "Roles"
    },
    "statusWarning": "The company {{name}} is inactive.",
    "tabs": {
      "billing": "Billing",
      "users": "Users",
      "access": "Access and Rights",
      "terms": "Terms and conditions",
      "api": "API",
      "directoryPresets": "Broadcast restriction presets",
      "revshare": "Revshare"
    },
    "revshare": {
      "averageTitle": "Average revenue share",
      "website": "Website",
      "aboveAverage": "Above average",
      "belowAverage": "Below average",
      "bulkUpdateAction": "Update selected revshare",
      "bulkUpdateTitle": "Update revenue share",
      "bulkUpdateSubmit_one": "Apply to {{count}} position",
      "bulkUpdateSubmit_other": "Apply to {{count}} positions"
    },
    "settings": {
      "defaultPriority": "Default priority",
      "defaultPriorityHelper": "Default priority for your AdGroups",
      "priorities": "AdGroup priorities",
      "addPriority": "Add a priority",
      "priorityDefaultName": "New Priority",
      "duplicatePriorities": "The same name is used multiple times",
      "usedPriorityDeletion": "Impossible to delete a used priority",
      "defaultPriorityDeletion": "Impossible to delete the default priority",
      "priorityIndexHelper": "An AdGroup with priority 1 will be displayed before an AdGroup with priority 2",
      "movePriorityUp": "Move priority up",
      "movePriorityDown": "Move priority down",
      "bannerSizes": "Banner sizes",
      "addBannerSize": "Add a banner size",
      "addBannerSizeModalTitle": "Add a banner size",
      "uploadBannerImage": "Upload an image",
      "uploadBannerImageHelper": "Upload a banner image to detect its width and height, then adjust the values if needed.",
      "bannerImageUploadError": "Unable to read the uploaded image.",
      "duplicateBannerSizes": "The same dimensions are used multiple times",
      "invalidBannerSize": "Width and height must be positive whole numbers",
      "bannerSizesEmpty": "No banner sizes configured",
      "bannerSizePreview": "Preview"
    },
    "copper": {
      "sectionTitle": "Copper"
    },
    "archiver": {
      "title": "Auto-archive",
      "helper": "Values inherited from the agency and parent reseller are shown automatically for advertisers. Enter 0 to disable auto-archive for that entity type.",
      "inherit": "Inherit from reseller",
      "unit_one": "month",
      "unit_other": "months",
      "disabled": "Disabled",
      "invalidMonths": "Enter a whole number of months greater than or equal to 0.",
      "months_one": "{{count}} month",
      "months_other": "{{count}} months",
      "fields": {
        "adcopyMonths": "Creatives",
        "adgroupMonths": "Ad groups",
        "adtemplateMonths": "Ad templates",
        "positionMonths": "Positions"
      }
    },
    "webhooks": {
      "title": "Webhooks",
      "url": "Webhook URL",
      "types": "Event types",
      "urlHelper": "Your endpoint receives a POST request with a JSON payload when an ad group status changes.",
      "eventType": "Event type",
      "eventTypeHelper": "Event: {{eventType}}. Payload event name: adgroup.status.changed.",
      "addWebhook": "Add a webhook",
      "saveSuccess": "Webhooks saved successfully.",
      "deleteSuccess": "Webhook deleted successfully.",
      "invalidUrl": "Please enter a valid URL",
      "typesRequired": "Select at least one event type",
      "duplicateUrls": "The same URL is used multiple times",
      "empty": "No webhook configured",
      "documentation": {
        "title": "Documentation",
        "open": "Documentation",
        "versionLabel": "Version",
        "versionOption": "Version {{version}}"
      }
    },
    "api": {
      "token": {
        "title": "API tokens",
        "create": "Create new token",
        "token": "Token",
        "createdAt": "Creation Date",
        "empty": "No token"
      },
      "routes": {
        "title": "Routes",
        "noData": "No data for this day",
        "parameter": {
          "date": "Should be the date of the data you want to get in the format YYYY-MM-DD",
          "dateIcon": "Change the date",
          "token": "Can be replace by any token of the company."
        }
      }
    }
  },
  "enum": {
    "AdFormat": {
      "Banner": "Banner",
      "Native": "Native",
      "Web": "Web"
    },
    "BiddingStrategy": {
      "MaxCpm": "Holistic Bidding (Maximize CPM)"
    },
    "ChannelType": {
      "Email": "Email",
      "Web": "Web"
    },
    "CompanyType": {
      "Advertiser": "Advertiser",
      "Agency": "Agency",
      "Publisher": "Publisher",
      "Reseller": "Reseller",
      "TradingDesk": "Trading Desk"
    },
    "CompanyWebhookType": {
      "AdGroupStatus": "Ad group status"
    },
    "EntityType": {
      "AdCopy": "Creative",
      "AdGroup": "Adgroup",
      "AdGroupBudgetPlan": "Budget plan",
      "AdGroupTargeting": "Adgroup targeting",
      "AdTemplate": "Template",
      "AdTemplateBanner": "Banner template",
      "AdTemplateImage": "Image template",
      "AdTemplateNative": "Native template",
      "AdTemplateWeb": "Web template",
      "AdgroupCustomCost": "Custom cost",
      "AdgroupDirectory": "Broadcast restriction",
      "AdgroupNetworkExtension": "Adgroup network",
      "AdgroupWebsiteDirectory": "Adgroup directory",
      "AdgroupWebsiteExclusion": "Adgroup directory",
      "Advertiser": "Advertiser",
      "Agency": "Agency",
      "BillingContact": "Billing contact",
      "Campaign": "Campaign",
      "Company": "Company",
      "CompanyApiToken": "API token",
      "CompanyArchiver": "Auto-archive policy",
      "CompanyWebhook": "Webhook",
      "InventorySelection": "Inventory selection",
      "Position": "Position",
      "PositionEmail": "Position",
      "PositionWeb": "Position",
      "ProgrammaticCampaign": "Programmatic campaign",
      "Publisher": "Publisher",
      "PublisherExclusionPreset": "Exclusion preset",
      "Reseller": "Reseller",
      "Segment": "Segment",
      "SegmentBehavioural": "Segment",
      "SegmentFile": "Segment",
      "TradingDesk": "Trading desk",
      "User": "User",
      "Website": "Website",
      "WebsiteCampaignExclusion": "Campaign exclusion",
      "WebsiteDomainExclusion": "Domain exclusion",
      "WebsiteIabExclusion": "IAB exclusion",
      "AdGroupDirectoryPreset": "Restriction preset"
    },
    "Currency": {
      "EUR": "EUR"
    },
    "IntegrationType": {
      "Direct": "Direct"
    },
    "InvoiceLanguage": {
      "en": "English",
      "fr": "French"
    },
    "InvoicingCompany": {
      "PowerspaceSAS": "Powerspace SAS",
      "WelcomeMediaSAS": "Welcome Media SAS"
    },
    "Network": {
      "Ecommerce": "Ecommerce",
      "Eshopper": "Eshopper",
      "Media": "Media",
      "Performance": "Performance",
      "Ebusiness": "Ebusiness"
    },
    "PositionType": {
      "InContent": "In Content",
      "InFeed": "In Feed",
      "RecommandationWidget": "Recommandation Widget",
      "SideContent": "Side Content"
    },
    "SubChannelType": {
      "ConfirmationPage": "Confirmation Page",
      "Newsletter": "Newsletter",
      "OrderConfirmationEmail": "Order Confirmation Email",
      "ProductListing": "Product Listing"
    },
    "SslStatus": {
      "Invalid": "Invalid",
      "NotLinked": "Not linked",
      "Pending": "Pending",
      "Valid": "Valid"
    },
    "genre": {
      "male": "Male",
      "female": "Female"
    },
    "AdvertiserGestion": {
      "Self": "Self",
      "Managed": "Managed"
    },
    "AdvertiserType": {
      "Direct": "Direct",
      "AgencyPerformance": "Performance Agency",
      "AgencyMedia": "Media Agency ",
      "AffiliationPlatform": "Affiliation Platform"
    },
    "UserRole": {
      "Finance": "Finance",
      "Marketing": "Marketing",
      "Sales": "Sales",
      "PublisherAccount": "Publisher Account",
      "Tech": "Tech",
      "Traffic": "Traffic"
    },
    "BudgetCapping": {
      "Monthly": "Monthly",
      "Overall": "Overall",
      "Open": "No limit",
      "Period": "Period"
    },
    "Gender": {
      "Male": "Male",
      "Female": "Female",
      "Unknown": "Unknown"
    },
    "DeviceType": {
      "Desktop": "Desktop",
      "Mobile": "Mobile",
      "Tablet": "Tablet",
      "Unknown": "Unknown"
    },
    "OsType": {
      "Android": "Android",
      "Ios": "iOS",
      "Macos": "macOS",
      "Windows": "Windows",
      "Unknown": "Unknown"
    },
    "Day": {
      "Monday": "Monday",
      "Tuesday": "Tuesday",
      "Wednesday": "Wednesday",
      "Thursday": "Thursday",
      "Friday": "Friday",
      "Saturday": "Saturday",
      "Sunday": "Sunday"
    }
  },
  "iabCategories": {
    "IAB1": "Arts & Entertainment",
    "IAB1-1": "Books & Literature",
    "IAB1-2": "Celebrity Fan/Gossip",
    "IAB1-3": "Fine Art",
    "IAB1-4": "Humor",
    "IAB1-5": "Movies",
    "IAB1-6": "Music",
    "IAB1-7": "Television",
    "IAB10": "Home & Garden",
    "IAB10-1": "Appliances",
    "IAB10-2": "Entertaining",
    "IAB10-3": "Environmental Safety",
    "IAB10-4": "Gardening",
    "IAB10-5": "Home Repair",
    "IAB10-6": "Home Theater",
    "IAB10-7": "Interior Decorating",
    "IAB10-8": "Landscaping",
    "IAB10-9": "Remodeling & Construction",
    "IAB11": "Law, Gov’t & Politics",
    "IAB11-1": "Immigration",
    "IAB11-2": "Legal Issues",
    "IAB11-3": "U.S. Government Resources",
    "IAB11-4": "Politics",
    "IAB11-5": "Commentary",
    "IAB12": "News",
    "IAB12-1": "International News",
    "IAB12-2": "National News",
    "IAB12-3": "Local News",
    "IAB13": "Personal Finance",
    "IAB13-1": "Beginning Investing",
    "IAB13-10": "Retirement Planning",
    "IAB13-11": "Stocks",
    "IAB13-12": "Tax Planning",
    "IAB13-2": "Credit/Debt & Loans",
    "IAB13-3": "Financial News",
    "IAB13-4": "Financial Planning",
    "IAB13-5": "Hedge Fund",
    "IAB13-6": "Insurance",
    "IAB13-7": "Investing",
    "IAB13-8": "Mutual Funds",
    "IAB13-9": "Options",
    "IAB14": "Society",
    "IAB14-1": "Dating",
    "IAB14-2": "Divorce Support",
    "IAB14-3": "Gay Life",
    "IAB14-4": "Marriage",
    "IAB14-5": "Senior Living",
    "IAB14-6": "Teens",
    "IAB14-7": "Weddings",
    "IAB14-8": "Ethnic Specific",
    "IAB15": "Science",
    "IAB15-1": "Astrology",
    "IAB15-10": "Weather",
    "IAB15-2": "Biology",
    "IAB15-3": "Chemistry",
    "IAB15-4": "Geology",
    "IAB15-5": "Paranormal Phenomena",
    "IAB15-6": "Physics",
    "IAB15-7": "Space/Astronomy",
    "IAB15-8": "Geography",
    "IAB15-9": "Botany",
    "IAB16": "Pets",
    "IAB16-1": "Aquariums",
    "IAB16-2": "Birds",
    "IAB16-3": "Cats",
    "IAB16-4": "Dogs",
    "IAB16-5": "Large Animals",
    "IAB16-6": "Reptiles",
    "IAB16-7": "Veterinary Medicine",
    "IAB17": "Sports",
    "IAB17-1": "Auto Racing",
    "IAB17-10": "Figure Skating",
    "IAB17-11": "Fly Fishing",
    "IAB17-12": "Football",
    "IAB17-13": "Freshwater Fishing",
    "IAB17-14": "Game & Fish",
    "IAB17-15": "Golf",
    "IAB17-16": "Horse Racing",
    "IAB17-17": "Horses",
    "IAB17-18": "Hunting/Shooting",
    "IAB17-19": "Inline Skating",
    "IAB17-2": "Baseball",
    "IAB17-20": "Martial Arts",
    "IAB17-21": "Mountain Biking",
    "IAB17-22": "NASCAR Racing",
    "IAB17-23": "Olympics",
    "IAB17-24": "Paintball",
    "IAB17-25": "Power & Motorcycles",
    "IAB17-26": "Pro Basketball",
    "IAB17-27": "Pro Ice Hockey",
    "IAB17-28": "Rodeo",
    "IAB17-29": "Rugby",
    "IAB17-3": "Bicycling",
    "IAB17-30": "Running/Jogging",
    "IAB17-31": "Sailing",
    "IAB17-32": "Saltwater Fishing",
    "IAB17-33": "Scuba Diving",
    "IAB17-34": "Skateboarding",
    "IAB17-35": "Skiing",
    "IAB17-36": "Snowboarding",
    "IAB17-37": "Surfing/Bodyboarding",
    "IAB17-38": "Swimming",
    "IAB17-39": "Table Tennis/Ping-Pong",
    "IAB17-4": "Bodybuilding",
    "IAB17-40": "Tennis",
    "IAB17-41": "Volleyball",
    "IAB17-42": "Walking",
    "IAB17-43": "Waterski/Wakeboard",
    "IAB17-44": "World Soccer",
    "IAB17-5": "Boxing",
    "IAB17-6": "Canoeing/Kayaking",
    "IAB17-7": "Cheerleading",
    "IAB17-8": "Climbing",
    "IAB17-9": "Cricket",
    "IAB18": "Style & Fashion",
    "IAB18-1": "Beauty",
    "IAB18-2": "Body Art",
    "IAB18-3": "Fashion",
    "IAB18-4": "Jewelry",
    "IAB18-5": "Clothing",
    "IAB18-6": "Accessories",
    "IAB19": "Technology & Computing",
    "IAB19-1": "3-D Graphics",
    "IAB19-10": "Computer Reviews",
    "IAB19-11": "Data Centers",
    "IAB19-12": "Databases",
    "IAB19-13": "Desktop Publishing",
    "IAB19-14": "Desktop Video",
    "IAB19-15": "Email",
    "IAB19-16": "Graphics Software",
    "IAB19-17": "Home Video/DVD",
    "IAB19-18": "Internet Technology",
    "IAB19-19": "Java",
    "IAB19-2": "Animation",
    "IAB19-20": "JavaScript",
    "IAB19-21": "Mac Support",
    "IAB19-22": "MP3/MIDI",
    "IAB19-23": "Net Conferencing",
    "IAB19-24": "Net for Beginners",
    "IAB19-25": "Network Security",
    "IAB19-26": "Palmtops/PDAs",
    "IAB19-27": "PC Support",
    "IAB19-28": "Portable",
    "IAB19-29": "Entertainment",
    "IAB19-3": "Antivirus Software",
    "IAB19-30": "Shareware/Freeware",
    "IAB19-31": "Unix",
    "IAB19-32": "Visual Basic",
    "IAB19-33": "Web Clip Art",
    "IAB19-34": "Web Design/HTML",
    "IAB19-35": "Web Search",
    "IAB19-36": "Windows",
    "IAB19-4": "C/C++",
    "IAB19-5": "Cameras & Camcorders",
    "IAB19-6": "Cell Phones",
    "IAB19-7": "Computer Certification",
    "IAB19-8": "Computer Networking",
    "IAB19-9": "Computer Peripherals",
    "IAB2": "Automotive",
    "IAB2-1": "Auto Parts",
    "IAB2-10": "Electric Vehicle",
    "IAB2-11": "Hatchback",
    "IAB2-12": "Hybrid",
    "IAB2-13": "Luxury",
    "IAB2-14": "MiniVan",
    "IAB2-15": "Motorcycles",
    "IAB2-16": "Off-Road Vehicles",
    "IAB2-17": "Performance Vehicles",
    "IAB2-18": "Pickup",
    "IAB2-19": "Road-Side Assistance",
    "IAB2-2": "Auto Repair",
    "IAB2-20": "Sedan",
    "IAB2-21": "Trucks & Accessories",
    "IAB2-22": "Vintage Cars",
    "IAB2-23": "Wagon",
    "IAB2-3": "Buying/Selling Cars",
    "IAB2-4": "Car Culture",
    "IAB2-5": "Certified Pre-Owned",
    "IAB2-6": "Convertible",
    "IAB2-7": "Coupe",
    "IAB2-8": "Crossover",
    "IAB2-9": "Diesel",
    "IAB20": "Travel",
    "IAB20-1": "Adventure Travel",
    "IAB20-10": "Canada",
    "IAB20-11": "Caribbean",
    "IAB20-12": "Cruises",
    "IAB20-13": "Eastern Europe",
    "IAB20-14": "Europe",
    "IAB20-15": "France",
    "IAB20-16": "Greece",
    "IAB20-17": "Honeymoons/Getaways",
    "IAB20-18": "Hotels",
    "IAB20-19": "Italy",
    "IAB20-2": "Africa",
    "IAB20-20": "Japan",
    "IAB20-21": "Mexico & Central America",
    "IAB20-22": "National Parks",
    "IAB20-23": "South America",
    "IAB20-24": "Spas",
    "IAB20-25": "Theme Parks",
    "IAB20-26": "Traveling with Kids",
    "IAB20-27": "United Kingdom",
    "IAB20-3": "Air Travel",
    "IAB20-4": "Australia & New Zealand",
    "IAB20-5": "Bed & Breakfasts",
    "IAB20-6": "Budget Travel",
    "IAB20-7": "Business Travel",
    "IAB20-8": "By US Locale",
    "IAB20-9": "Camping",
    "IAB21": "Real Estate",
    "IAB21-1": "Apartments",
    "IAB21-2": "Architects",
    "IAB21-3": "Buying/Selling Homes",
    "IAB22": "Shopping",
    "IAB22-1": "Contests & Freebies",
    "IAB22-2": "Couponing",
    "IAB22-3": "Comparison",
    "IAB22-4": "Engines",
    "IAB23": "Religion & Spirituality",
    "IAB23-1": "Alternative Religions",
    "IAB23-10": "Pagan/Wiccan",
    "IAB23-2": "Atheism/Agnosticism",
    "IAB23-3": "Buddhism",
    "IAB23-4": "Catholicism",
    "IAB23-5": "Christianity",
    "IAB23-6": "Hinduism",
    "IAB23-7": "Islam",
    "IAB23-8": "Judaism",
    "IAB23-9": "Latter-Day Saints",
    "IAB24": "Uncategorized",
    "IAB25": "Non-Standard Content",
    "IAB25-1": "Unmoderated UGC",
    "IAB25-2": "Extreme Graphic/Explicit Violence",
    "IAB25-3": "Pornography",
    "IAB25-4": "Profane Content",
    "IAB25-5": "Hate Content",
    "IAB25-6": "Under Construction",
    "IAB25-7": "Incentivized",
    "IAB26": "Illegal Content",
    "IAB26-1": "Illegal Content",
    "IAB26-2": "Warez",
    "IAB26-3": "Spyware/Malware",
    "IAB26-4": "Copyright Infringement",
    "IAB3": "Business",
    "IAB3-1": "Advertising",
    "IAB3-10": "Logistics",
    "IAB3-11": "Marketing",
    "IAB3-12": "Metals",
    "IAB3-2": "Agriculture",
    "IAB3-3": "Biotech/Biomedical",
    "IAB3-4": "Business Software",
    "IAB3-5": "Construction",
    "IAB3-6": "Forestry",
    "IAB3-7": "Government",
    "IAB3-8": "Green Solutions",
    "IAB3-9": "Human Resources",
    "IAB4": "Careers",
    "IAB4-1": "Career Planning",
    "IAB4-10": "U.S. Military",
    "IAB4-11": "Career Advice",
    "IAB4-2": "College",
    "IAB4-3": "Financial Aid",
    "IAB4-4": "Job Fairs",
    "IAB4-5": "Job Search",
    "IAB4-6": "Resume Writing/Advice",
    "IAB4-7": "Nursing",
    "IAB4-8": "Scholarships",
    "IAB4-9": "Telecommuting",
    "IAB5": "Education",
    "IAB5-1": "7-12 Education",
    "IAB5-10": "Homeschooling",
    "IAB5-11": "Homework/Study Tips",
    "IAB5-12": "K-6 Educators",
    "IAB5-13": "Private School",
    "IAB5-14": "Special Education",
    "IAB5-15": "Studying Business",
    "IAB5-2": "Adult Education",
    "IAB5-3": "Art History",
    "IAB5-4": "College Administration",
    "IAB5-5": "College Life",
    "IAB5-6": "Distance Learning",
    "IAB5-7": "English as a 2nd Language",
    "IAB5-8": "Language Learning",
    "IAB5-9": "Graduate School",
    "IAB6": "Family & Parenting",
    "IAB6-1": "Adoption",
    "IAB6-2": "Babies & Toddlers",
    "IAB6-3": "Daycare/Pre School",
    "IAB6-4": "Family Internet",
    "IAB6-5": "Parenting - K-6 Kids",
    "IAB6-6": "Parenting teens",
    "IAB6-7": "Pregnancy",
    "IAB6-8": "Special Needs Kids",
    "IAB6-9": "Eldercare",
    "IAB7": "Health & Fitness",
    "IAB7-1": "Exercise",
    "IAB7-10": "Brain Tumor",
    "IAB7-11": "Cancer",
    "IAB7-12": "Cholesterol",
    "IAB7-13": "Chronic Fatigue Syndrome",
    "IAB7-14": "Chronic Pain",
    "IAB7-15": "Cold & Flu",
    "IAB7-16": "Deafness",
    "IAB7-17": "Dental Care",
    "IAB7-18": "Depression",
    "IAB7-19": "Dermatology",
    "IAB7-2": "A.D.D.",
    "IAB7-20": "Diabetes",
    "IAB7-21": "Epilepsy",
    "IAB7-22": "GERD/Acid Reflux",
    "IAB7-23": "Headaches/Migraines",
    "IAB7-24": "Heart Disease",
    "IAB7-25": "Herbs for Health",
    "IAB7-26": "Holistic Healing",
    "IAB7-27": "IBS/Crohn’s Disease",
    "IAB7-28": "Incest/Abuse Support",
    "IAB7-29": "Incontinence",
    "IAB7-3": "AIDS/HIV",
    "IAB7-30": "Infertility",
    "IAB7-31": "Men’s Health",
    "IAB7-32": "Nutrition",
    "IAB7-33": "Orthopedics",
    "IAB7-34": "Panic/Anxiety Disorders",
    "IAB7-35": "Pediatrics",
    "IAB7-36": "Physical Therapy",
    "IAB7-37": "Psychology/Psychiatry",
    "IAB7-38": "Senior Health",
    "IAB7-39": "Sexuality",
    "IAB7-4": "Allergies",
    "IAB7-40": "Sleep Disorders",
    "IAB7-41": "Smoking Cessation",
    "IAB7-42": "Substance Abuse",
    "IAB7-43": "Thyroid Disease",
    "IAB7-44": "Weight Loss",
    "IAB7-45": "Women’s Health",
    "IAB7-5": "Alternative Medicine",
    "IAB7-6": "Arthritis",
    "IAB7-7": "Asthma",
    "IAB7-8": "Autism/PDD",
    "IAB7-9": "Bipolar Disorder",
    "IAB8": "Food & Drink",
    "IAB8-1": "American Cuisine",
    "IAB8-10": "Food Allergies",
    "IAB8-11": "French Cuisine",
    "IAB8-12": "Health/Lowfat Cooking",
    "IAB8-13": "Italian Cuisine",
    "IAB8-14": "Japanese Cuisine",
    "IAB8-15": "Mexican Cuisine",
    "IAB8-16": "Vegan",
    "IAB8-17": "Vegetarian",
    "IAB8-18": "Wine",
    "IAB8-2": "Barbecues & Grilling",
    "IAB8-3": "Cajun/Creole",
    "IAB8-4": "Chinese Cuisine",
    "IAB8-5": "Cocktails/Beer",
    "IAB8-6": "Coffee/Tea",
    "IAB8-7": "Cuisine-Specific",
    "IAB8-8": "Desserts & Baking",
    "IAB8-9": "Dining Out",
    "IAB9": "Hobbies & Interests",
    "IAB9-1": "Art/Technology",
    "IAB9-10": "Collecting",
    "IAB9-11": "Comic Books",
    "IAB9-12": "Drawing/Sketching",
    "IAB9-13": "Freelance Writing",
    "IAB9-14": "Genealogy",
    "IAB9-15": "Getting Published",
    "IAB9-16": "Guitar",
    "IAB9-17": "Home Recording",
    "IAB9-18": "Investors & Patents",
    "IAB9-19": "Jewelry Making",
    "IAB9-2": "Arts & Crafts",
    "IAB9-20": "Magic & Illusion",
    "IAB9-21": "Needlework",
    "IAB9-22": "Painting",
    "IAB9-23": "Photography",
    "IAB9-24": "Radio",
    "IAB9-25": "Roleplaying Games",
    "IAB9-26": "Sci-Fi & Fantasy",
    "IAB9-27": "Scrapbooking",
    "IAB9-28": "Screenwriting",
    "IAB9-29": "Stamps & Coins",
    "IAB9-3": "Beadwork",
    "IAB9-30": "Video & Computer Games",
    "IAB9-31": "Woodworking",
    "IAB9-4": "Birdwatching",
    "IAB9-5": "Board Games/Puzzles",
    "IAB9-6": "Candle & Soap Making",
    "IAB9-7": "Card Games",
    "IAB9-8": "Chess",
    "IAB9-9": "Cigars"
  },
  "layout": {
    "logout": "Logout",
    "navigation": {
      "open": "Open navigation"
    },
    "notifications": "Notifications",
    "profile": "My profile",
    "company": "My company",
    "theme": {
      "label": "Theme",
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    },
    "sidebar": {
      "close": "Close menu",
      "documentation": "Documentation",
      "feed": "Feed",
      "hideArchived": "Hide archived",
      "open": "Open menu",
      "showArchived": "Show archived",
      "seeCompany": "Go to Company",
      "advertiser": {
        "createAdgroup": "Create adgroup",
        "createCampaign": "Create campaign",
        "title": "Campaigns & Adgroups"
      },
      "publisher": {
        "createPosition": "Create position",
        "createWebsite": "Create website",
        "title": "Websites & Positions"
      }
    },
    "newFrontVersion": {
      "title": "Welcome to the new version of Powerspace",
      "oldUrlWarning": "You arrived here because you probably used a bookmark from the old version. You must save your bookmark again from this new version.",
      "loginNewVersion": "Discover the new version"
    },
    "documentation": "Documentation",
    "feed": "Feed",
    "hideArchived": "Hide archived",
    "showArchived": "Show archived",
    "seeCompany": "Go to Company"
  },
  "login": {
    "errors": {
      "credentialsError": "Error when fetching data for login:",
      "invalidEmail": "Invalid email"
    },
    "form": {
      "continue": "Continue",
      "orSeparator": "Or",
      "passwordRecovery": "Forgot your password?",
      "rememberMe": "Remember me"
    },
    "title": "Welcome"
  },
  "position": {
    "create": {
      "passbackStep": "Passback",
      "successMessage": "The position was successfully created",
      "title": "Create new position",
      "websiteStep": {
        "title": "Position's website",
        "websiteId": "Select the new position's website"
      }
    },
    "created": "New Position Created !",
    "updated": "Your position was updated!",
    "goToPosition": "Go to {{positionName}}",
    "preview": {
      "eyebrow": "Preview unavailable",
      "noActiveTemplate": "Cannot preview: no active template",
      "inactive": "Cannot preview: position is inactive",
      "archived": "Cannot preview: position is archived"
    },
    "settings": {
      "adPreview": "Preview",
      "addTag": {
        "noZoneWarning": "At least one zone is required to display Ad tag infos",
        "noAdTemplate": "No active template",
        "bottomMessage": {
          "email": "This is the code of the position that need to be installed in the HTML of your newsletter. It consists in one image URL and one clicks URL for each ad (zone). The values between \"$\" need to be replaced by the right info (do not keep the \"$\").",
          "web": "The values between \"{}\" need to be replaced by the right info (do not keep the \"{}\")."
        },
        "copyButton": {
          "copied": "Copied",
          "copy": "Copy",
          "copyAll": "Copy all"
        },
        "optionSwitches": {
          "age": "Age",
          "clearEmail": "Clear Email",
          "gender": "Gender",
          "md5Email": "MD5 Email",
          "sha256Email": "SHA256 Email",
          "location": "Location",
          "tooltip": {
            "md5Email": "Email hashed with MD5 algorithm",
            "sha256Email": "Email hashed with SHA256 algorithm",
            "gender": "Gender — Format: M/F or H/F",
            "age": "Date of birth — Format: ISO 8601 (YYYY-MM-DD)",
            "location": "Location — ps_z (zip code) and ps_c (country code) — Format: numeric postal code and country code ISO 3166-1 alpha-2 (e.g. 75001, FR)"
          }
        },
        "tagCode": {
          "endPageScriptMessage": "This is the code of the position that need to be installed in the HTML of your newsletter. It consists in one image URL and one clicks URL for each ad (zone). The values between \"$\" need to be replaced by the right info (do not keep the \"$\")."
        },
        "title": "Ad tag",
        "topLeft": {
          "customDomain": "Custom domain",
          "customDomainStatusInProgress": "SSL certificate creation in progress",
          "customDomainStatusInvalid": "SSL certificate is invalid. Ask Powerspace for more details.",
          "customDomainStatusInvalidWithFailure": "SSL certificate is invalid: {{failureReason}}",
          "customDomainStatusValid": "SSL certificate is valid",
          "customDomainStatusTooltip": "SSL: {{sslStatus}}",
          "customDomainStatusTooltipWithFailure": "SSL: {{sslStatus}} - Failure reason: {{failureReason}}",
          "customDomainInvalidStatus": "Custom domain setup is not valid yet",
          "webCSS": "CSS Template",
          "webHTML": "HTML",
          "webIframe": "Iframe"
        },
        "zone": "Zone",
        "adTemplateSelection": "Template selection",
        "noAdTemplateWithThisFormat": "No template with this format",
        "integrationCode": "Integration code",
        "atLeastBannerOrNative": "At least a banner template or a native template is required",
        "addZone": "Add a zone",
        "removeZone": "Remove zone"
      },
      "demandSource": {
        "editTitle": "Edit Demand Sources",
        "title": "Demand Sources"
      },
      "passBack": {
        "editTitle": "Edit PassBack Parameter",
        "passbackImage": "Passback Image",
        "passbackLink": "Passback Link",
        "title": "PassBack Parameter"
      },
      "summary": {
        "acceptGif": "Accept Gif",
        "biddingStrategy": "Bidding Strategy",
        "cpmFloor": "CPM Floor",
        "editTitle": "Edit Position Settings",
        "externalRevenueShare": "External Revenue Share",
        "integrationType": "Integration Type",
        "nbZone": "Number of zones",
        "revenueShare": "Revenue Share",
        "title": "Position Settings Summary",
        "shortCode": "Short code"
      }
    },
    "summary": {
      "channelType": "Channel Type",
      "editTitle": "Edit Position",
      "network": "Network",
      "positionType": "Type",
      "subchannelType": "Placement",
      "title": "Position Summary",
      "status": "Status"
    }
  },
  "search": {
    "adgroup": {
      "allFilter": "All AdGroups"
    },
    "allIAB": "All IAB Categories",
    "campaign": {
      "allFilter": "All Campaigns"
    },
    "defaultAllFilter": "All",
    "globalSearch": "Global search",
    "position": {
      "channelType": "Channel",
      "companyName": "Company",
      "id": "ID",
      "status": "Status",
      "marketCode": "Market",
      "nameWithWebsite": "Position Name",
      "network": "Network",
      "resellerName": "Reseller",
      "subchannelType": "Placement"
    },
    "resetFilters": "Reset filters",
    "user": {
      "selectCompany": "Select the company of the new user",
      "allFilter": "All Users"
    },
    "website": {
      "allFilter": "All Websites"
    }
  },
  "website": {
    "create": "Create New Website",
    "created": "New Website Created !",
    "updated": "Your website was updated",
    "name": "Site name",
    "url": "Site URL",
    "category": "Category",
    "market": "Market",
    "details": {
      "companyId": "Company",
      "iabCodeAndCategory": "IAB Category",
      "market": "Market",
      "positions": "Positions",
      "publisherId": "Company",
      "publisherName": "Company",
      "resellerName": "Reseller",
      "stepperTitle": "Website Details",
      "publisherStepTitle": "Publisher",
      "url": "URL"
    },
    "edit": {
      "sectionTitle": "Modify Website"
    },
    "goToWebsite": "Go to {{websiteName}}",
    "positionsHelper": "Optionally add positions to the new website. You can add several before finishing creation.",
    "sectionTitle": "Website Summary",
    "statusWarning": "The website {{name}} is inactive.",
    "tabs": {
      "dashboard": "Dashboard",
      "blacklist": "Blacklist"
    }
  },
  "stats": {
    "title": "Stats",
    "statsPerCampaignFor": "Stats per campaign {{iab}}",
    "globalStatsFor": "Global stats {{iab}}",
    "top10AdGroupsFor": "Top 10 adgroups {{iab}}",
    "common": {
      "invalidReason": {
        "title": "Reason",
        "CAMPAIGN_NOT_MATCHING": "The campaign provided doesn't match the campaign expected {{campaignId}}",
        "ALIAS": "The lead or the order has already been registered previously",
        "OLD_CLICK": "The click has expired before the lead or the order",
        "UNDEFINED_WON_BID": "No impression or click found for the lead or the order",
        "TEST": "Test",
        "NO_CLICK_FOUND": "No click found for the lead",
        "UNDEFINED_POSITION": "No position found for the lead or order",
        "BLACKLISTED": "User is blacklisted",
        "EMAIL_BLACKLISTED": "Email is blacklisted",
        "BLACKLISTED_PROFILE": "User is blacklisted"
      }
    },
    "maxDetailsMessage": "You cannot display detailed stats for more than {{maxMonths}} months.",
    "chart": {
      "close": "Close chart",
      "showFullscreen": "Show chart",
      "title": "Chart"
    },
    "filter": {
      "datesRange": "Dates",
      "Channel": "Channel Type",
      "Market": "Market",
      "Network": "Network",
      "DemandSource": "Demand Sources",
      "granularity": "Granularity",
      "timeframe": "Timeframe",
      "dataTypes": "Data types",
      "kpi": "KPI",
      "timeframeValues": {
        "today": "Today",
        "yesterday": "Yesterday",
        "thisDayLastWeek": "This day last week",
        "last3Days": "Last 3 days",
        "last30Days": "Last 30 days",
        "last60Days": "Last 60 days",
        "thisMonth": "This month",
        "lastMonth": "Last month",
        "thisQuarter": "This quarter",
        "lastQuarter": "Last quarter",
        "last3Month": "Last 3 month",
        "thisWeek": "This week",
        "lastWeek": "Last week",
        "thisYear": "This year",
        "lastYear": "Last year",
        "custom": "custom"
      },
      "kpiSelection_one": "1 kpi selected",
      "kpiSelection_other": "{{count}} kpi selected",
      "displayValues": "Display values"
    },
    "table": {
      "date": "Date",
      "commissions": "Commissions",
      "rpm": "RPM",
      "displays": "Displays",
      "channelType": "Channel",
      "lr": "LR",
      "or": "OR",
      "dailyBudget": "Daily budget"
    },
    "customDisplay": {
      "publisher": {
        "displays": "Displays",
        "commissions": "Commissions",
        "cpc": "CPC",
        "rpm": "RPM",
        "lr": "LR",
        "or": "OR",
        "impression": " Impressions & Displays",
        "userEvent": "Clicks",
        "costRatio": "CTR",
        "costStats": "RPM & CPM & CPC"
      },
      "advertiser": {
        "impression": "Impressions",
        "cpc": "CPC",
        "cpl": "CPL",
        "cpo": "CPO",
        "rpm": "RPM",
        "lr": "LR",
        "or": "OR",
        "userEvent": "Clicks",
        "costRatio": "CTR",
        "costStats": "CPM & CPC",
        "costs": "Costs",
        "roi": "ROI",
        "adGroups": "AdGroups",
        "campaigns": "Campaigns",
        "analytics": "Analytics"
      }
    },
    "dataTypes": {
      "devices": "Devices",
      "timeseries": "Timeseries",
      "campaigns": "Campaigns",
      "positions": "Positions",
      "resellers": "Demand sources",
      "adTemplates": "Templates",
      "websitesAndPositions": "Websites and Positions",
      "advertisers": "Advertisers",
      "adcopies": "Creatives",
      "adgroups": "AdGroups",
      "publishers": "Publishers",
      "zones": "Zones"
    },
    "powerspace": {
      "budgets": {
        "revenue": "Revenue",
        "dailyBudget": "Daily budget",
        "campaigns": "Campaigns",
        "adGroups": "AdGroups",
        "cpc": "CPC",
        "cpm": "CPM"
      }
    },
    "granularity": {
      "Hour": "per hour",
      "Day": "per day",
      "Week": "per week",
      "Month": "per month",
      "Year": "per year"
    }
  },
  "advertiser": {
    "settings": {
      "gestion": "Advertiser gestion mode",
      "subType": "Advertiser type",
      "unknownTrafficRate": "Allowed unknown traffic rate",
      "unknownTrafficRateDescription": "The allowed unknown traffic rate is the maximum percentage of clicks or leads that can be considered as valid from unknown source.",
      "copperCompany": "Copper company",
      "unlinkCopperCompany": "Remove Copper company link",
      "unlinkAgency": "Remove agency link"
    }
  },
  "agency": {
    "settings": {
      "copperCompany": "Copper company",
      "unlinkCopperCompany": "Remove Copper company link"
    }
  },
  "tradingDesk": {
    "sectionTitle": "Trading desk",
    "settings": {
      "seats": "Seats",
      "dsp": "dsp",
      "seat": "seat"
    }
  },
  "programmaticCampaign": {
    "sectionTitle": "Programmatic campaign",
    "statusWarning": "The programmatic campaign {{name}} is stopped."
  },
  "report": {
    "autoReload": {
      "5m": "5 minutes",
      "10m": "10 minutes",
      "20m": "20 minutes",
      "30m": "30 minutes"
    }
  },
  "activity": {
    "autoReload": {
      "30s": "30 seconds",
      "1m": "1 minute",
      "5m": "5 minutes",
      "pageOneOnly": "Auto-reload is only active on page 1"
    },
    "refresh": "Refresh",
    "todayTitle": "Today ({{date}})",
    "yesterdayTitle": "Yesterday ({{date}})",
    "earlierTitle": "Earlier",
    "feed": {
      "userNotFound": "User not found",
      "propertyOfEntity": "property {{property}} of",
      "fromOldValueToNewValue": "from {{oldValue}} to {{newValue}}",
      "oldToNew": "{{oldValue}} → {{newValue}}",
      "changed": "Changed",
      "seeAllChanges": "See all",
      "showAllChanges": "Show all changes",
      "showLimitedChanges": "Show fewer changes",
      "status": "status",
      "of": "of",
      "from": "from",
      "fromRestrictionListOf": "from the restriction list of",
      "fromExclusionPresetOf": "from the exclusion preset",
      "to": "to",
      "toRestrictionListOf": "to the restriction list of",
      "toExclusionPresetOf": "to the exclusion preset",
      "created": "Created",
      "updated": "Updated",
      "invited": "Invited",
      "withId": "with id",
      "toJoinCompany": "to join {{companyName}}",
      "doneAutomaticallyByPlatform": "Done automatically by the platform",
      "platform": "Platform",
      "userPasswordUpdatedBeforeUser": "The password of",
      "userPasswordUpdatedAfterUser": "has been changed",
      "geoTargetingChanged": "Geotargeting has been changed",
      "adTemplateNativeContentUpdatedBeforeTemplate": "the content of the template",
      "properties": {
        "acceptEditorial": "Accept editorial",
        "acceptGif": "Accept GIF",
        "acceptPromotional": "Accept promotional",
        "accessType": "Access type",
        "accountingId": "Accounting ID",
        "accountManagerId": "Account manager",
        "active": "Active",
        "addressLine1": "Address line 1",
        "adgroupDirectory": "Broadcast restriction",
        "adjustment": "Adjustment",
        "advertiserName": "Advertiser name",
        "agencyId": "Agency",
        "ageRange": "Age range",
        "archived": "Archived",
        "autoSegments": "Auto-segments",
        "backgroundColor": "Background color",
        "bankName": "Bank name",
        "biddingStrategy": "Bidding strategy",
        "budget": "Budget",
        "budgetCapping": "Budget capping",
        "budgetCappingType": "Budget capping type",
        "budgetPlan": "Planned budget change",
        "callToAction": "Call to action",
        "channelEmail": "Email",
        "channelType": "Channel type",
        "channelWeb": "Web",
        "cities": "Cities",
        "city": "City",
        "comments": "Comments",
        "company": "Company",
        "campaign": "Campaign",
        "iabCategory": "IAB category",
        "contactEmail": "Contact email",
        "content": "Content",
        "conversionClickAge": "Conversion click age",
        "cost": "Cost",
        "costModel": "Cost model",
        "costType": "Type",
        "costValue": "Cost",
        "countries": "Countries",
        "countryBlacklistRedirectUrl": "Country blacklist redirect URL",
        "countryId": "Country",
        "cpc": "CPC",
        "cpm": "CPM",
        "cpmFloor": "CPM floor",
        "css": "CSS",
        "cssSelector": "CSS selector",
        "cssSelectorPosition": "CSS selector position",
        "currency": "Currency",
        "dailyBudget": "Daily budget",
        "dailyBudgetType": "Daily budget type",
        "dayWeek": "Day of week",
        "dealId": "Deal ID",
        "defaultCpc": "Default CPC",
        "demandSources": "Demand sources",
        "departements": "Departments",
        "description": "Description",
        "deviceExclusive": "Device exclusive",
        "deviceType": "Device type",
        "directoryPositionIds": "Directory positions",
        "directoryPresetIds": "Broadcast restriction presets",
        "directoryWebsiteIds": "Directory websites",
        "email": "Email",
        "endDate": "End date",
        "externalRevenueShare": "External revenue share",
        "fax": "Fax",
        "firstName": "First name",
        "forceRedirectUrl": "URL redirect",
        "format": "Format",
        "gender": "Gender",
        "genericName": "Generic name",
        "geoExclusive": "Geo exclusive",
        "geoTargeting": "Geo targeting",
        "geoTargetingType": "Geo targeting type",
        "gestion": "Advertiser gestion mode",
        "hourDay": "Hour of day",
        "iban": "IBAN",
        "image": "Image",
        "integrationType": "Integration type",
        "invoicingCompany": "Billing entity",
        "isActive": "Active",
        "isArchived": "Archived",
        "js": "JavaScript",
        "kpis": "KPIs",
        "label": "Label",
        "landline": "Landline",
        "language": "Language",
        "lastName": "Last name",
        "market": "Market",
        "marketId": "Market",
        "masterTemplate": "Master template",
        "mobile": "Mobile",
        "name": "Name",
        "nbZone": "Number of zones",
        "network": "Network",
        "networkExtensions": "Network extensions",
        "numberCampaignExclusions": "Campaign exclusions",
        "numberCustomCosts": "Custom costs",
        "numberWebsiteExclusions": "Website exclusions",
        "osExclusive": "OS exclusive",
        "os": "OS",
        "osType": "OS type",
        "passbackImage": "Passback image",
        "passbackJs": "Passback JS",
        "passbackLink": "Passback link",
        "password": "Password",
        "paymentTerm": "Payment terms",
        "permissions": {
          "api": "API",
          "web": "Web channel",
          "banner": "Banner channel",
          "adgroupCpm": "CPM cost",
          "adgroupCpl": "CPL cost",
          "adgroupExclusions": "Broadcast restriction",
          "adgroupCustomcpcs": "Bid adjustments",
          "adgroupReportwebsites": "Report by website",
          "adgroupUsertargeting": "Demographic targeting",
          "adgroupGeotargeting": "Geographic targeting",
          "adgroupDevicetargeting": "Device targeting",
          "adgroupTimetargeting": "Hour and day targeting",
          "adgroupSegments": "CRM segments",
          "adgroupAutoSegments": "Auto-segments",
          "adgroupPriority": "Ad group priority",
          "adgroupMonthlyBudgetCapping": "Monthly budget capping",
          "adgroupOverallBudgetCapping": "Overall budget capping",
          "adgroupOpenBudgetCapping": "Open budget capping",
          "adgroupOpenDailyBudget": "Open daily budget",
          "adCopyDates": "Creative dates",
          "positionAdvancedsettings": "Position advanced settings",
          "websiteExclusions": "Website campaign exclusions",
          "advertiserDirectoryPresets": "Directory presets",
          "publisherBlacklistPresets": "Blacklist presets"
        },
        "phone": "Phone",
        "positionIds": "Position",
        "positionType": "Position type",
        "priorityId": "Priority",
        "profileTagIds": "Profile tags",
        "rawGeoTargeting": "Geo targeting",
        "redirectUrl": "Redirect URL",
        "regions": "Regions",
        "registrationId": "Registration ID",
        "revenueShare": "Revenue share",
        "role": "Role",
        "rootDomain": "Root domain",
        "rules": "Rules",
        "salesManagerId": "Sales manager",
        "secret": "Secret",
        "segmentIds": "Segments",
        "slackId": "Slack ID",
        "slug": "Company subdomain",
        "sspId": "SSP ID",
        "startDate": "Start date",
        "status": "Status",
        "subchannelType": "Placement",
        "subType": "Subtype",
        "swift": "SWIFT / BIC",
        "tags": "Tags",
        "targetUnknownAge": "Unknown age",
        "taxId": "Tax ID",
        "template": "Template",
        "title": "Title",
        "unknownTrafficRate": "Unknown traffic rate",
        "url": "URL",
        "userCappingTimeframe": "User capping period",
        "userCappingType": "User capping type",
        "userCappingValue": "User capping value",
        "vatId": "VAT ID",
        "website": "Website",
        "websiteIds": "Website",
        "websiteName": "Website name",
        "weight": "Diffusion weight",
        "zipCode": "Zipcode",
        "zones": "Zones",
        "zoneTemplate": "Zone template"
      },
      "deleted": "Deleted",
      "added": "Added",
      "removed": "Removed",
      "addedOnZoneTheTemplate": "on the zone {{zone}} the template",
      "removedFromZoneTheTemplate": "from the zone {{zone}} the template",
      "valueToPropertyOfEntity": "{{value}} to property {{property}} of",
      "valueFromPropertyOfEntity": "{{value}} from property {{property}} of"
    }
  },
  "serverError": {
    "Wrong credentials": "Invalid email or password.",
    "ONLY_ADTEMPLATE_ERROR": "Impossible to disable the only active template for this position."
  },
  "templateEditor": {
    "createMobileVersion": "Are you sure you want to create a Mobile Version of this Ad Template?",
    "control": {
      "addElement": "Add elements",
      "addShape": "Add {{name}}",
      "addPlaceholderCustomText": "Add '{{name}}' text",
      "addImage": "Add image placeholder with ratio {{ratio}}",
      "backgroundColor": "Background color",
      "background": "Background",
      "borderRadius": "Radius",
      "changeBackgroundColor": "Change background color",
      "fontWeight": "Bold",
      "font": "Font",
      "fontStyle": "Italic",
      "underline": "Underline",
      "upperCase": "toggle upper case",
      "width": "Width",
      "height": "Height",
      "fontSize": "Font Size",
      "textColor": "Text color",
      "left": "From left",
      "top": "From top",
      "transparentBackground": "Transparent background",
      "text": "Text",
      "imageplaceholder": "image placeholder",
      "imageSizeLimit": "The image exceeds the maximum dimensions, it will be resized to fit within {{width}}x{{height}}.",
      "moveForward": "Bring to front",
      "moveBackward": "Send to background",
      "align": {
        "left": "Align left",
        "center": "Align center",
        "right": "Align right",
        "top": "Align top",
        "middle": "Align middle",
        "bottom": "Align bottom"
      },
      "templateBackgroundColor": "Background color",
      "templateBackgroundImage": "Choose a background",
      "newText": "New text",
      "placeholderAlreadyExists": "Placeholder {{placeholder}} already exists in the template",
      "imageAlreadyExists": "An image already exists in the template",
      "removeBackground": "Remove background image",
      "settings": "Template settings",
      "stroke": "Stroke color",
      "strokeWidth": "Stroke width",
      "shape": "Shape",
      "zoom": "Zoom"
    },
    "oneImageMax": "Only one image is allowed in the template",
    "duplicatedPlaceholder": "Placeholders must be unique",
    "title": "Template Editor",
    "preview": {
      "title": "Template Preview"
    },
    "unsavedChanged": "There are unsaved changes on this template. Are you sure you want to switch to {{versionType}} ? All unsaved changes will be lost.",
    "versionType": {
      "main": "Main version",
      "mobile": "Mobile version"
    },
    "importTemplate": "Import template",
    "importTemplateSuccess": "Template has been imported !",
    "chooseTemplate": "Choose a template",
    "imageSizeWarning": "For correct centering, the size of the image should match the template size displayed above. You can still save the image, but the centering may be off.",
    "imageOutOfTemplate": "The main image of this template has parts outside of the template, this can result in a poorly cut image and lower CTR.",
    "canvasSizeWarning": "Images with width under 400px could be pixelated, to display correctly a small templace, increase the width of this one and fix the size in your CSS."
  },
  "table": {
    "columns": "Columns",
    "comparisonFilter": {
      "after": "After",
      "before": "Before",
      "between": "Between",
      "end": "End",
      "lessThan": "Less than",
      "lessThanOrEqual": "Less than or equals",
      "moreThan": "More than",
      "moreThanOrEqual": "More than or equals",
      "operator": "Date filter",
      "start": "Start"
    },
    "emptyValues": "Empty values",
    "filterValue": "Filter value",
    "nonEmptyValues": "Non-empty values"
  },
  "resetPassword": {
    "enterNewPassword": "Please enter your new password",
    "login": "Login",
    "emailSentMessage": "An email has been sent to <strong>{{email}}</strong>. Please click on the link inside in order to create a new password If you don't receive this email, please check your spams",
    "newPassword": "New password",
    "resetSuccess": "Your password has been successfully reset. You can now login with your new password",
    "requestInstruction": "Fill in your email below, and you will receive instructions to reset your password",
    "returnToLogin": "Return to login",
    "requestResetPassword": "Request reset password",
    "resetPasswordSubmit": "Reset Password",
    "title": "Forgot your password?",
    "serverError": {
      "tokenExpired": "Sorry, this password reset link has expired. Please request a new password reset link and try again."
    }
  },
  "invitation": {
    "acceptInvitation": "Accept invitation",
    "title": "Account creation",
    "contactDetails": "your contact details",
    "password": "Password",
    "acceptInviteSuccess": "Your account has been successfully created. You can now login with your email and password",
    "goToLogin": "Go to login page",
    "serverError": {
      "invalidToken": "Sorry, this invitation link is invalid. Please request a new invitation link and try again."
    },
    "AcceptInvitation": "Accept invitation"
  },
  "ErrorBoundaryUIFallback": {
    "eyebrow": "Oops!",
    "somethingWentWrong": "Something unexpected happened.",
    "apologizeInconvenience": "Sorry for the trouble. Refreshing the page often fixes it.",
    "refreshPage": "Refresh page"
  },
  "NotFoundPage": {
    "eyebrow": "404",
    "title": "We can't find this page.",
    "description": "The link may be outdated, or the page may have moved. Let's get you back on track.",
    "backToHome": "Back to dashboard",
    "backToLogin": "Back to login"
  },
  "adTest": {
    "settings": {
      "zoom": "Preview size"
    }
  },
  "simulation": {
    "title": "Reach simulation",
    "description": "Configure market, network, targeting, and optional broadcast restriction presets to preview estimated reach without saving.",
    "disclaimer": "Changes on this page are not saved. Use it to explore reach impact before updating an ad group.",
    "directory": {
      "title": "Broadcast restriction"
    },
    "reach": {
      "info": "This estimate does not include geotargeting and segments."
    },
    "errors": {
      "market": "Unable to load markets for simulation."
    }
  },
  "home": {
    "tabs": {
      "powerspace": "Powerspace",
      "activityfeed": "Activity Feed",
      "adTest": "Preview",
      "reports": "Reports",
      "companies": "Companies",
      "adgroups": "AdGroups",
      "websites": "Websites",
      "positions": "Positions",
      "users": "Users"
    }
  },
  "impersonation": {
    "connectAs": "Connect as {{firstName}} {{lastName}}",
    "confirm": "Connect as {{firstName}} {{lastName}}? You will browse the app in read-only mode as this user.",
    "banner": "Viewer mode: you are connected as {{firstName}} {{lastName}} ({{email}}).",
    "quit": "Quit impersonation",
    "errors": {
      "notAuthenticated": "You must be logged in to impersonate a user.",
      "startFailed": "Unable to start impersonation."
    }
  },
  "directoryPresets": {
    "createTitle": "Create restriction list",
    "editTitle": "Edit restriction list",
    "description": "Create broadcast restriction presets to reuse the same website and position restrictions across your ad groups.",
    "created": "Restriction preset created",
    "saved": "Restriction preset saved",
    "deleted": "Restriction preset deleted",
    "deleteConfirm": "Delete restriction list {{name}}? This also removes it from every ad group that selected it.",
    "addTitle": "Add websites",
    "duplicateName": "This name is already used by another restriction list",
    "view": "View",
    "viewTitle": "Restriction list",
    "unassign": "Unassign"
  },
  "billing": {
    "actionButtons": {
      "download": "Download",
      "edit": "Edit",
      "validate": "Validate",
      "validateAll": "Validate selected invoices",
      "recordPayment": "Record payment",
      "downloadInvoices": "Download selected invoices"
    },
    "editInvoice": {
      "comment": "Comment",
      "publisher": "Publisher",
      "billedTo": "Billed to",
      "invoiceNb": "Invoice n°",
      "payment": "Payment",
      "description": "Description / advertising commissions",
      "updated": "Invoice updated",
      "totalExcludingTaxes": "Subtotal",
      "totalIncludingTaxes": "Total Including Taxes",
      "title": "Edit invoice",
      "vat": "VAT"
    },
    "confirmValidation": "Are you sure you want to change the invoice(s) status to VALIDATED? The interested contacts will be notified and a copy of the invoice(s) will be shared.",
    "invoicesAlreadyGenerated": "All invoices for this period has already been generated",
    "downloadError": "An error occurred while downloading the invoice. Please try again or contact support.",
    "downloadInvoice": "Download invoice",
    "generateInvoices": "Generate invoices",
    "generatedSuccess": "Invoice successfully generated",
    "minAmount": "Min amount",
    "paidInvoice": {
      "title": "Record payment",
      "saved": "Payment has been recorded",
      "paidWarning": "Are you sure you want to change the invoice status to PAID? The interested contacts will be notified and a copy of the invoice will be shared. The invoice will be permanently marked as paid and no other changes will be possible."
    },
    "Paid": "Paid",
    "Pending": "Pending",
    "Validated": "Validated",
    "reference": "Reference",
    "period": "Period",
    "publisherName": "Publisher",
    "advertiserName": "Advertiser",
    "amount": "Amount",
    "tax": "Tax",
    "total": "Total amount",
    "date": "Date",
    "dueDate": "Due date",
    "previewInvoice": "Preview invoice",
    "summary": "Invoice summary",
    "selectedCount_one": "{{count}} invoice selected",
    "selectedCount_other": "{{count}} invoices selected",
    "validated": "Invoice has been validated"
  },
  "publisher": {
    "analyze": {
      "title": "Analyze",
      "privateStatsMessage": "These statistics are private and only visible to Powerspace. Do not share them with your clients.",
      "populationStats": {
        "title": "Population",
        "os": "OS",
        "deviceType": "Device type",
        "ageRange": "Age range",
        "gender": "Gender"
      }
    },
    "blacklist": {
      "title": "Blacklists",
      "advertisers": "Excluded Advertisers",
      "advertisersDescription": "Block delivery to selected advertisers.",
      "campaigns": "Excluded Campaigns",
      "campaignsDescription": "Block delivery to selected campaigns.",
      "addAdvertisers": "Add blacklisted Advertisers",
      "addCampaigns": "Add blacklisted Campaigns",
      "addDomains": "Add blacklisted Domains",
      "addIabCategories": "Add blacklisted Iab Categories",
      "newlyAddedAdvertisers": "advertiser(s) selected",
      "newlyAddedCampaigns": "campaign(s) selected",
      "newlyAddedCategories": "iab(s) selected",
      "domainSeparators": "Domains must be separated by a space or a comma",
      "domainPlaceholder": "Type here to blacklist domains",
      "iab": "Excluded IAB Categories",
      "iabDescription": "Block delivery on content matching selected IAB categories.",
      "domains": "Excluded Domains",
      "domainsDescription": "Block delivery on selected advertiser domains.",
      "publisherExclusionsTitle": "Publisher exclusions",
      "publisherExclusionsDescription": "Configure exclusions applied to this publisher, including assigned presets and direct exclusions.",
      "resellerExclusionsTitle": "Reseller exclusions",
      "resellerExclusionsDescription": "Configure exclusions applied to this reseller and inherited by its publishers and websites.",
      "websiteExclusionsTitle": "Website exclusions",
      "websiteExclusionsDescription": "Configure exclusions applied to this website, including assigned presets and direct exclusions.",
      "publisherExclusionListsTitle": "Publisher exclusion preset",
      "publisherExclusionListsDescription": "Create and manage reusable exclusion presets for this publisher. Assign them from the exclusions section below.",
      "resellerExclusionListsTitle": "Reseller exclusion preset",
      "resellerExclusionListsDescription": "Create and manage reusable exclusion presets for this reseller. These presets are available to all publishers and websites of this reseller. Assign them from the exclusions section below.",
      "presets": {
        "title": "Exclusion presets",
        "assignDescription": "Apply reusable exclusion presets to this scope.",
        "name": "Preset name",
        "use": "Use a preset",
        "createNew": "Create preset",
        "assigned": "Assigned",
        "unassign": "Unassign",
        "noAvailablePresets": "No presets available to assign.",
        "noOwnedPresets": "No owned presets yet.",
        "noAssignedPresets": "No presets assigned yet.",
        "resellerAssignDescription": "Presets assigned here apply to all publishers and websites under this reseller.",
        "ownedTitle": "Owned presets",
        "deleteConfirm": "Delete this exclusion preset?",
        "createTitle": "Create exclusion preset",
        "editTitle": "Edit exclusion preset",
        "loadError": "Failed to load exclusion preset.",
        "viewTitle": "Exclusion preset",
        "noExclusions": "No exclusions in this category.",
        "convertToPreset": "Convert to preset",
        "convertToPresetTitle": "Convert blacklist to preset",
        "ownerCompany": "Owner company",
        "replaceWithPresetConfirm": "Replace the current blacklist with preset {{name}}?",
        "replaceWithPresetApplied": "Preset applied and blacklist cleared",
        "duplicateName": "This name is already used by another exclusion preset",
        "domainsPreservedOnConvert": "Domain exclusions cannot be stored in presets and will remain on this object.",
        "created": "Exclusion preset created",
        "convertToPresetDisabledAssignedPreset": "A preset is already assigned. Remove assigned presets before converting the blacklist.",
        "convertToPresetDisabledEmpty": "There are no advertiser, campaign, or IAB exclusions to convert."
      },
      "filters": {
        "advertiserName": "Advertiser name",
        "name": "Campaign Name",
        "iab": "IAB Category"
      },
      "table": {
        "advertiser": {
          "parent": "Parent",
          "name": "Advertiser",
          "createdAt": "Creation date",
          "actions": "Actions"
        },
        "campaign": {
          "parent": "Parent",
          "advertiser": "Advertiser",
          "name": "Campaign",
          "advertiserDomainName": "Domain",
          "createdAt": "Creation date",
          "actions": "Actions"
        },
        "parent": "Parent",
        "iab": "IAB Category",
        "domain": "Domain",
        "createdAt": "Creation date",
        "actions": "Actions"
      }
    }
  },
  "reseller": {
    "assistantRules": {
      "title": "Assistant",
      "table": {
        "key": "Key",
        "type": "Type"
      },
      "fields": {
        "isActive": "Active",
        "importance": "Importance",
        "config": "Configuration",
        "configDescription": "Conditions that must be met for this rule to run. Each row is a scope, field, operator, and value. Use the logic control to require all conditions or any one of them.",
        "recommendedChanges": "Recommended changes",
        "recommendedChangesDescription": "Optional actions suggested when the rule matches (for example updating a field). Leave this empty if the rule should only rely on its title and description without suggested changes.",
        "entity": "Entity",
        "message": "Message",
        "key": "Key",
        "value": "Value"
      },
      "modal": {
        "title": "Edit rule: {{name}}",
        "key": "Rule key: {{key}}",
        "createUserRuleTitle": "Create user rule",
        "editUserRule": "Edit user rule",
        "editSystemRule": "Edit system rule",
        "basicInfo": "Basic Information",
        "descriptionPlaceholder": "Describe what this rule does and when it should trigger"
      },
      "actions": {
        "createUserRule": "Create user rule"
      },
      "sections": {
        "systemRules": "System rules",
        "userRules": "User rules"
      },
      "errors": {
        "invalidJson": "Configuration must be valid JSON.",
        "invalidRecommendedChangesJson": "Recommended changes must be a valid JSON array.",
        "invalidJsonObject": "Configuration must be a valid JSON object.",
        "missingRuleKey": "This rule cannot be edited because its key is missing.",
        "noSchemaForRuleKey": "No dedicated schema found for this system rule key. Falling back to JSON editor.",
        "emptyConfig": "No configuration keys available for this rule.",
        "expectedString": "Value must be a string.",
        "expectedBoolean": "Value must be a boolean.",
        "deleteUserRule": "Failed to delete the rule. Please try again."
      },
      "configFields": {
        "adcopiesForBudget": "Ad copies for budget",
        "maxLifetimeDays": "Duration of an A/B test",
        "weeklyClickThreshold": "Weekly click threshold for an A/B test",
        "minimumAdCopies": "Minimum ad copies",
        "minimumBudgetPerAdCopy": "Minimum budget per ad copy",
        "maximumAdCopies": "Maximum ad copies",
        "minimumImpressions": "Minimum impressions",
        "minimumDaysSinceLastAbTest": "Minimum days since last A/B test",
        "minimumAbTestImpressions": "Minimum A/B test impressions",
        "maximumImbalanceRatio": "Maximum imbalance ratio",
        "minimumRemainingDays": "Minimum remaining days",
        "minimumDailyBudget": "Minimum daily budget"
      },
      "systemRuleDescriptions": {
        "AdCopyMaxLifetimeExceeded": "One or more creatives have reached the maximum lifetime.",
        "AdGroupNotEnoughAdCopiesForBudget": "The ad group does not have enough creatives for the current budget.",
        "AdGroupTooManyAdCopiesForBudget": "The ad group has too many creatives for the current budget.",
        "AdGroupAdCopyReadyForNewAbTest": "The ad group has a creative ready for a new A/B test.",
        "AdGroupImbalancedAbTestImpressions": "The ad group has imbalanced A/B test impressions.",
        "AdGroupIncreaseDailyBudgetForBudgetCapping": "The daily budget capping is too low. Increase daily budget or switch to automatic daily budget."
      },
      "systemRuleConfigKeys": {
        "AdGroupNotEnoughAdCopiesForBudget": {
          "adcopiesForBudget": "Ad copies for budget"
        }
      },
      "conditionEditor": {
        "logic": "Logic",
        "all": "Every rule should be valid",
        "any": "Only one rule should be valid",
        "scope": "Scope",
        "field": "Field",
        "operator": "Operator",
        "action": "Action",
        "value": "Value",
        "params": "Params",
        "addCondition": "Add condition",
        "compareField": "Compare field",
        "compareFieldNeedsPrimary": "Select a condition field first",
        "compareFieldPrimaryUnavailable": "This field cannot be used for comparison",
        "compareToField": "Switch to field comparison",
        "compareToValue": "Switch to value comparison"
      },
      "fieldTypeHints": {
        "currency": "Currency",
        "percent": "Percent",
        "count": "Count",
        "number": "Number",
        "boolean": "Boolean"
      },
      "paramsFields": {
        "periodDays": "Number of Days",
        "skipRecentDays": "Recent days to skip"
      },
      "operators": {
        "Between": "Between",
        "Contains": "Contains",
        "Eq": "Equals",
        "Falsy": "Is false",
        "Gt": "Greater than",
        "Gte": "Greater than or equal",
        "In": "In list",
        "Intersects": "Intersects",
        "IsEmpty": "Is empty",
        "IsNotEmpty": "Is not empty",
        "Lt": "Less than",
        "Lte": "Less than or equal",
        "Neq": "Not equals",
        "NotContains": "Does not contain",
        "Truthy": "Is true",
        "Delete": "Delete",
        "Replace": "Replace",
        "Update": "Update"
      },
      "recommendedChangesEditor": {
        "group": "Logic",
        "all": "Every recommended change rule should be valid",
        "any": "Only one recommended change rule should be valid",
        "messagePlaceholder": "Describe what to change when this rule is triggered (e.g., 'Increase daily budget to €50')",
        "messagePerConditionPlaceholder": "Optional message for this specific condition",
        "noChanges": "No recommended changes yet. Add a group to get started.",
        "noActions": "No actions yet. Click \"Add action\" to define what should change.",
        "addGroup": "Add recommendation group",
        "conditions": "Conditions",
        "actionsDescription": "Add a row for each setting this recommendation refers to.",
        "addAction": "Add action",
        "howToFixThat": "Why is it necessary and how to fix it?",
        "doAllNecessary": "Make all necessary changes",
        "onlyOneChange": "Only one change can be made"
      },
      "scopes": {
        "adGroup": "AdGroup",
        "adCopies": "Creatives",
        "adGroupTargeting": "AdGroup Targeting"
      },
      "scopeSubCategories": {
        "demographics": "Demographics",
        "geoTargeting": "Geo targeting",
        "deviceOs": "Device & OS",
        "timeTargeting": "Time targeting",
        "reach": "Reach",
        "other": "Other",
        "stats": "Stats"
      },
      "scopeFields": {
        "monthlyBudget": "Monthly Budget",
        "overallBudget": "Overall Budget",
        "startDate": "Start Date",
        "endDate": "End Date",
        "stats.averageDaySpent": "Average Day Spent",
        "stats.yesterdayImpressions": "Yesterday Impressions",
        "stats.yesterdayClicks": "Yesterday Clicks",
        "stats.yesterdayLeads": "Yesterday Leads",
        "stats.yesterdayOrders": "Yesterday Orders",
        "stats.yesterdayCtr": "Yesterday CTR",
        "stats.yesterdayLr": "Yesterday LR",
        "stats.yesterdayOr": "Yesterday OR",
        "stats.averageDailyImpressions": "Average Daily Impressions",
        "stats.averageDailyClicks": "Average Daily Clicks",
        "stats.averageDailyLeads": "Average Daily Leads",
        "stats.averageDailyOrders": "Average Daily Orders",
        "stats.averageDailyCtr": "Average Daily CTR",
        "stats.averageDailyLr": "Average Daily LR",
        "stats.averageDailyOr": "Average Daily OR",
        "cpc": "CPC",
        "cpm": "CPM",
        "cpl": "CPL",
        "cpo": "CPO",
        "userCappingUncapped": "User Capping Uncapped",
        "userCappingImpression": "User Capping Impressions",
        "userCappingClick": "User Capping Click",
        "status": "Status",
        "dailyBudgetAuto": "Daily Budget Auto",
        "dailyBudgetFixed": "Daily Budget Fixed",
        "dailyBudgetOpen": "Daily Budget Open",
        "budgetCappingType": "Budget Capping Type",
        "dailyBudgetType": "Daily Budget Type",
        "device.type": "Device Type",
        "os.exclusive": "OS Exclusive",
        "os.type": "OS Type",
        "gender": "Gender",
        "age.range": "Age Range",
        "age.unknown": "Target Unknown Age",
        "device.exclusive": "Device Exclusive",
        "time.days": "Days",
        "time.hours": "Hours",
        "geoTargeting.geoExclusive": "Geo Targeting Exclusive",
        "geoTargeting.countries": "Geo Targeting Countries",
        "geoTargeting.geoTargetingType": "Geo Targeting Type",
        "geoTargeting.cities": "Geo Targeting Cities",
        "geoTargeting.regions": "Geo Targeting Regions",
        "geoTargeting.departements": "Geo Targeting Departments",
        "reach.impressions": "Reach Impressions",
        "reach.cpc": "Reach CPC",
        "count": "Count",
        "statuses": "Statuses",
        "titles": "Titles",
        "callToActions": "Call To Actions"
      },
      "fieldUnits": {
        "Currency": "€",
        "Percent": "%",
        "Count": "#"
      },
      "scopeFieldDescriptions": {
        "monthlyBudget": "Maximum amount the ad group can spend per month.",
        "overallBudget": "Total budget cap for the ad group over its lifetime.",
        "startDate": "First day the ad group is eligible to run.",
        "endDate": "Last day the ad group is eligible to run.",
        "stats.averageDaySpent": "Average daily spend over the selected stats period.",
        "stats.yesterdayImpressions": "Impressions recorded on the previous day.",
        "stats.yesterdayClicks": "Clicks recorded on the previous day.",
        "stats.yesterdayLeads": "Leads recorded on the previous day.",
        "stats.yesterdayOrders": "Orders recorded on the previous day.",
        "stats.yesterdayCtr": "Click-through rate for the previous day.",
        "stats.yesterdayLr": "Lead rate for the previous day.",
        "stats.yesterdayOr": "Order rate for the previous day.",
        "stats.averageDailyImpressions": "Average impressions per day.",
        "stats.averageDailyClicks": "Average clicks per day.",
        "stats.averageDailyLeads": "Average leads per day.",
        "stats.averageDailyOrders": "Average orders per day.",
        "stats.averageDailyCtr": "Average daily click-through rate.",
        "stats.averageDailyLr": "Average daily lead rate.",
        "stats.averageDailyOr": "Average daily order rate.",
        "cpc": "Cost per click.",
        "cpm": "Cost per thousand impressions.",
        "cpl": "Cost per lead.",
        "cpo": "Cost per order.",
        "userCappingUncapped": "Whether user-level frequency capping is disabled.",
        "userCappingImpression": "User frequency cap based on impressions.",
        "userCappingClick": "User frequency cap based on clicks.",
        "status": "AdGroup status.",
        "dailyBudgetAuto": "Daily budget when using automatic pacing.",
        "dailyBudgetFixed": "Daily budget when set to a fixed amount.",
        "dailyBudgetOpen": "Daily budget in open-ended mode.",
        "budgetCappingType": "How spend is limited relative to the budget.",
        "dailyBudgetType": "Strategy used for the daily budget.",
        "device.type": "Device category targeted.",
        "os.exclusive": "Whether targeting is exclusive to one OS family.",
        "os.type": "Operating system family targeted.",
        "gender": "Gender demographic targeting.",
        "age.range": "Age bracket targeted.",
        "age.unknown": "Whether unknown-age users are included.",
        "device.exclusive": "Whether targeting is exclusive to one device type.",
        "time.days": "Days of the week included in scheduling.",
        "time.hours": "Hours of the day included in scheduling.",
        "geoTargeting.geoExclusive": "Whether geo targeting is targeted or excluded.",
        "geoTargeting.countries": "Countries included or excluded in targeting.",
        "geoTargeting.geoTargetingType": "Mode of geographic targeting.",
        "geoTargeting.cities": "Cities included or excluded in targeting.",
        "geoTargeting.regions": "Regions included or excluded in targeting.",
        "geoTargeting.departements": "Departments included or excluded in targeting.",
        "reach.impressions": "Average impressions for the target population.",
        "reach.cpc": "Average CPC for the target population.",
        "count": "Number of creatives.",
        "statuses": "Creative status values to match.",
        "titles": "Creative titles to match.",
        "callToActions": "Call-to-action labels to match."
      }
    }
  },
  "powerspace": {
    "account": {
      "title": "Accounting",
      "table": {
        "yesterdayCpm": "Yesterday's CPM",
        "lastModified": "Last modified",
        "remainingTime": "Remaining time",
        "budget": "Budget",
        "current": "Current",
        "spentToday": "Spent today",
        "recommendation": "Recommendation",
        "recommendationsCount_one": "1 recommendation",
        "recommendationsCount_other": "{{count}} recommendations"
      },
      "warning": {
        "dailyBudgetThreshold": "Daily budget is higher than {{threshold}}€",
        "cpmThreshold": "CPM is lower than the reseller's average CPM of {{resellerCPM}}€"
      }
    },
    "population": {
      "title": "Reach Population"
    },
    "budgets": {
      "title": "Daily budgets",
      "accountFilter": "Account",
      "salesFilter": "Sales",
      "dailyRepartition": "Daily budget",
      "revenueRepartition": "Revenue",
      "cpcRepartition": "CPC",
      "cpmRepartition": "CPM",
      "advertiserRepartition": "Advertisers",
      "campaignRepartition": "Campaigns",
      "dayBudgetRatio": "{{ratio}}% of this day's budget",
      "spentOverDailyBudget": "{{spent}} spent over {{budget}} daily budget"
    },
    "demandSources": {
      "title": "Demand sources",
      "impressions": "Impressions",
      "unfilled": "Unfilled",
      "powerspace": "Powerspace",
      "other": "Others"
    },
    "adProductTiers": {
      "category": "Category",
      "adGroupsCount_one": "{{count}} ad group",
      "adGroupsCount_other": "{{count}} ad groups",
      "repartition": {
        "impressions": "Impressions",
        "clicks": "Clicks",
        "costs": "Costs"
      },
      "details": {
        "adGroups": "Ad groups",
        "ageGender": "Age & gender",
        "age": "By age range",
        "gender": "By gender",
        "ageRepartition": "Impressions by age range",
        "genderRepartition": "Impressions by gender",
        "ageGenderUnavailable": "Age and gender breakdown is only available for full tier categories.",
        "websites": "Websites",
        "iabCategories": "IAB categories",
        "otherCategories": "Other categories"
      }
    },
    "adGroups": {
      "title": "AdGroups Analysis",
      "tabs": {
        "iabCategory": "IAB category",
        "iabContent": "IAB AD Product"
      },
      "iabRepartition": {
        "title": "IAB category repartition",
        "revenues": "Revenues per IAB",
        "otherDetails": "Other",
        "minor": "IAB category repartition"
      },
      "top10AdGroups": "Top 10 ad groups",
      "iabTotalStats": "IAB Total Stats",
      "globalCampaignStats": "Global Campaign Stats",
      "globalIabRevenues": "Global IAB Revenues"
    },
    "validation": {
      "title": "Creative validation",
      "empty": "No ad copies are waiting for validation."
    }
  },
  "sentEmail": {
    "verified": "At least one email to this address was received",
    "lastEmailError": "The last email to this address failed",
    "emailDoesNotExist": "The recipient address does not exist",
    "statusPending": "Pending",
    "statusReceived": "Received",
    "statusError": "Error",
    "invoiceSectionTitle": "Sent emails",
    "invoiceEmpty": "No emails have been sent for this invoice yet.",
    "subject": "Subject",
    "type": "Type",
    "sentAt": "Sent at",
    "types": {
      "Invoice": "Invoice",
      "Invite": "Invitation",
      "ResetPassword": "Password reset"
    }
  },
  "updated": "Updated"
}
